import BigNumber from 'bignumber.js'
import { ethers } from 'bs-ethers'
import { MINTTOKEN } from '../constants/bakery'
import axios from 'axios'
import BakerySwapPairAbi from './lib/abi/BakerySwapPair.json'

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80
})
export const getNblAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.nbl && sushi.contracts.nbl.options.address
}
export const getNblContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.nbl
}
export const getNblBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.nblBnbBlp && sushi.contracts.nblBnbBlp.options.address
}
export const getNblBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.nblBnbBlp
}
export const getEarnNblMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.earnNblMaster && sushi.contracts.earnNblMaster.options.address
}
export const getEarnNblMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.earnNblMaster
}
export const getKxaAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kxa && sushi.contracts.kxa.options.address
}
export const getKxaContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kxa
}
export const getKxaMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kxaMaster && sushi.contracts.kxaMaster.options.address
}
export const getKxaMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kxaMaster
}
export const getKxaBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kxaBnbBlp && sushi.contracts.kxaBnbBlp.options.address
}
export const getKxaBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kxaBnbBlp
}
export const getMoniAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.moni && sushi.contracts.moni.options.address
}
export const getMoniContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.moni
}
export const getMoniMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.moniMaster && sushi.contracts.moniMaster.options.address
}
export const getMoniMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.moniMaster
}
export const getMoniBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.moniBnbBlp && sushi.contracts.moniBnbBlp.options.address
}
export const getMoniBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.moniBnbBlp
}
export const getKmoNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kmoNFT && sushi.contracts.kmoNFT.options.address
}
export const getKmoNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kmoNFT
}
export const getNtAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.nt && sushi.contracts.nt.options.address
}
export const getNtContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.nt
}
export const getNtMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ntMaster && sushi.contracts.ntMaster.options.address
}
export const getNtMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ntMaster
}
export const getNtBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ntBnbBlp && sushi.contracts.ntBnbBlp.options.address
}
export const getNtBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ntBnbBlp
}
export const getKTreasureAdvancedAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kTreasureAdvanced && sushi.contracts.kTreasureAdvanced.options.address
}
export const getKTreasureAdvancedContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kTreasureAdvanced
}

export const getKRabbitAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kRabbit && sushi.contracts.kRabbit.options.address
}
export const getKRabbitContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kRabbit
}

export const getDonAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.don && sushi.contracts.don.options.address
}
export const getDonContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.don
}
export const getDonMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.donMaster && sushi.contracts.donMaster.options.address
}
export const getDonMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.donMaster
}
export const getDonBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.donBnbBlp && sushi.contracts.donBnbBlp.options.address
}
export const getDonBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.donBnbBlp
}
export const getKalataAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kalata && sushi.contracts.kalata.options.address
}
export const getKalataContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kalata
}
export const getKalataMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kalataMaster && sushi.contracts.kalataMaster.options.address
}
export const getKalataMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kalataMaster
}
export const getKalataBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kalataBnbBlp && sushi.contracts.kalataBnbBlp.options.address
}
export const getKalataBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.kalataBnbBlp
}
export const getEggAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.egg && sushi.contracts.egg.options.address
}
export const getEggContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.egg
}
export const getEggMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.eggMaster && sushi.contracts.eggMaster.options.address
}
export const getEggMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.eggMaster
}
export const getEggBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.eggBnbBlp && sushi.contracts.eggBnbBlp.options.address
}
export const getEggBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.eggBnbBlp
}
export const getDogoAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dogo && sushi.contracts.dogo.options.address
}
export const getDogoContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dogo
}
export const getDogoMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dogoMaster && sushi.contracts.dogoMaster.options.address
}
export const getDogoMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dogoMaster
}
export const getDogoBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dogoBnbBlp && sushi.contracts.dogoBnbBlp.options.address
}
export const getDogoBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dogoBnbBlp
}
export const getBmoncNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bmoncNFT && sushi.contracts.bmoncNFT.options.address
}
export const getBmoncNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bmoncNFT
}
export const getBmoncAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bmonc && sushi.contracts.bmonc.options.address
}
export const getBmoncContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bmonc
}
export const getStakeBmoncEarnBmonAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.stakeBmoncEarnBmon && sushi.contracts.stakeBmoncEarnBmon.options.address
}
export const getStakeBmoncEarnBmonContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.stakeBmoncEarnBmon
}
export const getBnrgBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bnrgBnbBlp && sushi.contracts.bnrgBnbBlp.options.address
}
export const getBnrgBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bnrgBnbBlp
}
export const getBnrgAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bnrg && sushi.contracts.bnrg.options.address
}
export const getBnrgContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bnrg
}
export const getBmonAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bmon && sushi.contracts.bmon.options.address
}
export const getBmonContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bmon
}
export const getBmonBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bmonBnbBlp && sushi.contracts.bmonBnbBlp.options.address
}
export const getBmonBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bmonBnbBlp
}
export const getBmonBusdBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bmonBusdBlp && sushi.contracts.bmonBusdBlp.options.address
}
export const getBmonBusdBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bmonBusdBlp
}
export const getEarnBnrgMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.earnBnrgMaster && sushi.contracts.earnBnrgMaster.options.address
}
export const getEarnBnrgMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.earnBnrgMaster
}
export const getGaAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.ga &&
    sushi.contracts.ga.options.address
  )
}
export const getGaContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ga
}
export const getNewDonghuangArtAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.newDonghuangArt &&
    sushi.contracts.newDonghuangArt.options.address
  )
}
export const getNewDonghuangArtContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.newDonghuangArt
}
export const getBakerySoccerCommonStakeERC721EarnBake3Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.bakerySoccerCommonStakeERC721EarnBake3 &&
    sushi.contracts.bakerySoccerCommonStakeERC721EarnBake3.options.address
  )
}
export const getBakerySoccerCommonStakeERC721EarnBake3Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakerySoccerCommonStakeERC721EarnBake3
}
export const getDoggyNFTCommonStakeERC721EarnBake3Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.doggyNFTCommonStakeERC721EarnBake3 &&
    sushi.contracts.doggyNFTCommonStakeERC721EarnBake3.options.address
  )
}
export const getDoggyNFTCommonStakeERC721EarnBake3Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyNFTCommonStakeERC721EarnBake3
}
export const getBarkingNFTCommonStakeERC721EarnBake3Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.barkingNFTCommonStakeERC721EarnBake3 &&
    sushi.contracts.barkingNFTCommonStakeERC721EarnBake3.options.address
  )
}
export const getBarkingNFTCommonStakeERC721EarnBake3Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.barkingNFTCommonStakeERC721EarnBake3
}
export const getDoggyEquipmentCommonStakeERC721EarnBake3Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.doggyEquipmentCommonStakeERC721EarnBake3 &&
    sushi.contracts.doggyEquipmentCommonStakeERC721EarnBake3.options.address
  )
}
export const getDoggyEquipmentCommonStakeERC721EarnBake3Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyEquipmentCommonStakeERC721EarnBake3
}
export const getBakeMuskMixerCommonStakeERC721EarnBake3Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.bakeMuskMixerCommonStakeERC721EarnBake3 &&
    sushi.contracts.bakeMuskMixerCommonStakeERC721EarnBake3.options.address
  )
}
export const getBakeMuskMixerCommonStakeERC721EarnBake3Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeMuskMixerCommonStakeERC721EarnBake3
}
export const getPokerCardCommonStakeERC721EarnBake3Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.pokerCardCommonStakeERC721EarnBake3 &&
    sushi.contracts.pokerCardCommonStakeERC721EarnBake3.options.address
  )
}
export const getPokerCardCommonStakeERC721EarnBake3Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pokerCardCommonStakeERC721EarnBake3
}
export const getComboNFTCommonStakeERC721EarnBake3Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.comboNFTCommonStakeERC721EarnBake3 &&
    sushi.contracts.comboNFTCommonStakeERC721EarnBake3.options.address
  )
}
export const getComboNFTCommonStakeERC721EarnBake3Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.comboNFTCommonStakeERC721EarnBake3
}
export const getCarNFTCommonStakeERC721EarnBake3Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.carNFTCommonStakeERC721EarnBake3 &&
    sushi.contracts.carNFTCommonStakeERC721EarnBake3.options.address
  )
}
export const getCarNFTCommonStakeERC721EarnBake3Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.carNFTCommonStakeERC721EarnBake3
}
export const getBakeBusdBlpAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.bakeBusdBlp &&
    sushi.contracts.bakeBusdBlp.options.address
  )
}
export const getBakeBusdBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeBusdBlp
}
export const getBakerySoccerCommonStakeERC721EarnBake2Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.bakerySoccerCommonStakeERC721EarnBake2 &&
    sushi.contracts.bakerySoccerCommonStakeERC721EarnBake2.options.address
  )
}
export const getBakerySoccerCommonStakeERC721EarnBake2Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakerySoccerCommonStakeERC721EarnBake2
}
export const getDoggyNFTCommonStakeERC721EarnBake2Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.doggyNFTCommonStakeERC721EarnBake2 &&
    sushi.contracts.doggyNFTCommonStakeERC721EarnBake2.options.address
  )
}
export const getDoggyNFTCommonStakeERC721EarnBake2Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyNFTCommonStakeERC721EarnBake2
}
export const getBarkingNFTCommonStakeERC721EarnBake2Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.barkingNFTCommonStakeERC721EarnBake2 &&
    sushi.contracts.barkingNFTCommonStakeERC721EarnBake2.options.address
  )
}
export const getBarkingNFTCommonStakeERC721EarnBake2Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.barkingNFTCommonStakeERC721EarnBake2
}
export const getDoggyEquipmentCommonStakeERC721EarnBake2Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.doggyEquipmentCommonStakeERC721EarnBake2 &&
    sushi.contracts.doggyEquipmentCommonStakeERC721EarnBake2.options.address
  )
}
export const getDoggyEquipmentCommonStakeERC721EarnBake2Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyEquipmentCommonStakeERC721EarnBake2
}
export const getBakeMuskMixerCommonStakeERC721EarnBake2Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.bakeMuskMixerCommonStakeERC721EarnBake2 &&
    sushi.contracts.bakeMuskMixerCommonStakeERC721EarnBake2.options.address
  )
}
export const getBakeMuskMixerCommonStakeERC721EarnBake2Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeMuskMixerCommonStakeERC721EarnBake2
}
export const getPokerCardCommonStakeERC721EarnBake2Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.pokerCardCommonStakeERC721EarnBake2 &&
    sushi.contracts.pokerCardCommonStakeERC721EarnBake2.options.address
  )
}
export const getPokerCardCommonStakeERC721EarnBake2Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pokerCardCommonStakeERC721EarnBake2
}
export const getComboNFTCommonStakeERC721EarnBake2Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.comboNFTCommonStakeERC721EarnBake2 &&
    sushi.contracts.comboNFTCommonStakeERC721EarnBake2.options.address
  )
}
export const getComboNFTCommonStakeERC721EarnBake2Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.comboNFTCommonStakeERC721EarnBake2
}
export const getCarNFTCommonStakeERC721EarnBake2Address = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.carNFTCommonStakeERC721EarnBake2 &&
    sushi.contracts.carNFTCommonStakeERC721EarnBake2.options.address
  )
}
export const getCarNFTCommonStakeERC721EarnBake2Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.carNFTCommonStakeERC721EarnBake2
}
export const getBusdBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.busdBnbBlp && sushi.contracts.busdBnbBlp.options.address
}
export const getBusdBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.busdBnbBlp
}
export const getUsdtBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.usdtBnbBlp && sushi.contracts.usdtBnbBlp.options.address
}
export const getUsdtBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.usdtBnbBlp
}
export const getMasterChef2Address = sushi => {
  return sushi && sushi.contracts && sushi.contracts.masterChef2 && sushi.contracts.masterChef2.options.address
}
export const getMasterChef2Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.masterChef2
}
export const getToysCommonNftMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.toysCommonNftMaster && sushi.contracts.toysCommonNftMaster.options.address
}
export const getToysCommonNftMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.toysCommonNftMaster
}
export const getBethMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bethMaster && sushi.contracts.bethMaster.options.address
}
export const getBethMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bethMaster
}
export const getKtaNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ktaNFT && sushi.contracts.ktaNFT.options.address
}
export const getKtaNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ktaNFT
}
export const getTokauMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokauMaster && sushi.contracts.tokauMaster.options.address
}
export const getTokauMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokauMaster
}
export const getwsgAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.wsg && sushi.contracts.wsg.options.address
}
export const getWsgContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.wsg
}
export const getWsgBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.wsgBnbBlp && sushi.contracts.wsgBnbBlp.options.address
}
export const getWsgBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.wsgBnbBlp
}
export const getWsgMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.wsgMaster && sushi.contracts.wsgMaster.options.address
}
export const getWsgMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.wsgMaster
}
export const getGatBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.gatBnbBlp && sushi.contracts.gatBnbBlp.options.address
}
export const getGatBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.gatBnbBlp
}
export const getGatBakeBaseIDOAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.gatBakeBaseIDO && sushi.contracts.gatBakeBaseIDO.options.address
}
export const getGatBakeBaseIDOContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.gatBakeBaseIDO
}
export const getGatTlmMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.gatTlmMaster && sushi.contracts.gatTlmMaster.options.address
}
export const getGatTlmMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.gatTlmMaster
}
export const getLevAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.lev && sushi.contracts.lev.options.address
}
export const getLevContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.lev
}
export const getSiBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.siBnbBlp && sushi.contracts.siBnbBlp.options.address
}
export const getSiBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.siBnbBlp
}
export const getLiBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.liBnbBlp && sushi.contracts.liBnbBlp.options.address
}
export const getLiBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.liBnbBlp
}
export const getLevBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.levBnbBlp && sushi.contracts.levBnbBlp.options.address
}
export const getLevBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.levBnbBlp
}
export const getLevMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.levMaster && sushi.contracts.levMaster.options.address
}
export const getLevMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.levMaster
}
export const getToysAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.toys && sushi.contracts.toys.options.address
}
export const getToysContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.toys
}
export const getGatAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.gat && sushi.contracts.gat.options.address
}
export const getGatContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.gat
}
export const getDoggyEquipmentCommonStakeERC721EarnBakeAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.doggyEquipmentCommonStakeERC721EarnBake &&
    sushi.contracts.doggyEquipmentCommonStakeERC721EarnBake.options.address
  )
}
export const getDoggyEquipmentCommonStakeERC721EarnBakeContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyEquipmentCommonStakeERC721EarnBake
}
export const getDoggyEquipmentAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyEquipment && sushi.contracts.doggyEquipment.options.address
}
export const getDoggyEquipmentContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyEquipment
}
export const getMatrixPlusBoxCommonStakeERC721EarnBakeBoxAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.matrixPlusBoxCommonStakeERC721EarnBake &&
    sushi.contracts.matrixPlusBoxCommonStakeERC721EarnBake.options.address
  )
}
export const getMatrixPlusBoxCommonStakeERC721EarnBakeContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.matrixPlusBoxCommonStakeERC721EarnBake
}
export const getMatrixPlusBoxAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.matrixPlusBox && sushi.contracts.matrixPlusBox.options.address
}
export const getMatrixPlusBoxContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.matrixPlusBox
}
export const getTokauNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokauNFT && sushi.contracts.tokauNFT.options.address
}
export const getTokauNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokauNFT
}
export const getDogeAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doge && sushi.contracts.doge.options.address
}
export const getDogeContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doge
}
export const getXmsBakeBaseIDOAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.xmsBakeBaseIDO && sushi.contracts.xmsBakeBaseIDO.options.address
}
export const getXmsBakeBaseIDOContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.xmsBakeBaseIDO
}
export const getBscBakeNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bscBakeNFT && sushi.contracts.bscBakeNFT.options.address
}
export const getBscBakeNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bscBakeNFT
}
export const getExchangeBscBakeNFTAddress = sushi => {
  return (
    sushi && sushi.contracts && sushi.contracts.exchangeBscBakeNFT && sushi.contracts.exchangeBscBakeNFT.options.address
  )
}
export const getExchangeBscBakeNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeBscBakeNFT
}
export const getBidBscBakeNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidBscBakeNFT && sushi.contracts.bidBscBakeNFT.options.address
}
export const getBidBscBakeNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidBscBakeNFT
}
export const getTokauAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokau && sushi.contracts.tokau.options.address
}
export const getTokauContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokau
}
export const getTokauBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokauBnbBlp && sushi.contracts.tokauBnbBlp.options.address
}
export const getTokauBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokauBnbBlp
}
export const getTokauTlmBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokauTlmBlp && sushi.contracts.tokauTlmBlp.options.address
}
export const getTokauTlmBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokauTlmBlp
}
export const getTokauTlmMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokauTlmMaster && sushi.contracts.tokauTlmMaster.options.address
}
export const getTokauTlmMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokauTlmMaster
}
export const getExchangeBarkingNFTAddress = sushi => {
  return (
    sushi && sushi.contracts && sushi.contracts.exchangeBarkingNFT && sushi.contracts.exchangeBarkingNFT.options.address
  )
}
export const getExchangeBarkingNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeBarkingNFT
}
export const getBidBarkingNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidBarkingNFT && sushi.contracts.bidBarkingNFT.options.address
}
export const getBidBarkingNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidBarkingNFT
}
export const getBarkingNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.barkingNFT && sushi.contracts.barkingNFT.options.address
}
export const getBarkingNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.barkingNFT
}
export const getBarkingNFTCommonStakeERC721EarnBakeAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.barkingNFTCommonStakeERC721EarnBake &&
    sushi.contracts.barkingNFTCommonStakeERC721EarnBake.options.address
  )
}
export const getBarkingNFTCommonStakeERC721EarnBakeContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.barkingNFTCommonStakeERC721EarnBake
}
export const getTokauBakeBaseIDOAddress = sushi => {
  return (
    sushi && sushi.contracts && sushi.contracts.tokauBakeBaseIDO && sushi.contracts.tokauBakeBaseIDO.options.address
  )
}
export const getTokauBakeBaseIDOContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokauBakeBaseIDO
}
export const getBarkAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bark && sushi.contracts.bark.options.address
}
export const getBarkContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bark
}
export const getBarkDoggyBLpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.barkDoggyBLp && sushi.contracts.barkDoggyBLp.options.address
}
export const getBarkDoggyBLpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.barkDoggyBLp
}
export const getBarkBnbBLpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.barkBnbBLp && sushi.contracts.barkBnbBLp.options.address
}
export const getBarkBnbBLpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.barkBnbBLp
}
export const getBarkTlmMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.barkTlmMaster && sushi.contracts.barkTlmMaster.options.address
}
export const getBarkTlmMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.barkTlmMaster
}
export const getMintAddress = sushi => {
  return sushi && sushi.mintAddress
}
export const getRacaAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.raca && sushi.contracts.raca.options.address
}
export const getRacaContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.raca
}
export const getRacaNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.racaNFT && sushi.contracts.racaNFT.options.address
}
export const getRacaNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.racaNFT
}
export const getExchangeRacaNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeRacaNFT && sushi.contracts.exchangeRacaNFT.options.address
}
export const getExchangeRacaNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeRacaNFT
}
export const getBidRacaNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidRacaNFT && sushi.contracts.bidRacaNFT.options.address
}
export const getBidRacaNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidRacaNFT
}
export const getGinuAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ginu && sushi.contracts.ginu.options.address
}
export const getGinuContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ginu
}
export const getGinuBnbBLpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ginuBnbBLp && sushi.contracts.ginuBnbBLp.options.address
}
export const getGinuBnbBLpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ginuBnbBLp
}
export const getGinuMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ginuMaster && sushi.contracts.ginuMaster.options.address
}
export const getGinuMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ginuMaster
}
export const getLoveNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.loveNFT && sushi.contracts.loveNFT.options.address
}
export const getLoveNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.loveNFT
}
export const getExchangeLoveNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeLoveNFT && sushi.contracts.exchangeLoveNFT.options.address
}
export const getExchangeLoveNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeLoveNFT
}
export const getBidLoveNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidLoveNFT && sushi.contracts.bidLoveNFT.options.address
}
export const getBidLoveNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidLoveNFT
}
export const getBondlyAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bondly && sushi.contracts.bondly.options.address
}
export const getBondlyContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bondly
}
export const getBondlyBnbBLpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bondlyBnbBLp && sushi.contracts.bondlyBnbBLp.options.address
}
export const getBondlyBnbBLpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bondlyBnbBLp
}
export const getBondlyMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bondlyMaster && sushi.contracts.bondlyMaster.options.address
}
export const getBondlyMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bondlyMaster
}
export const getBondlyNftAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bondlyNft && sushi.contracts.bondlyNft.options.address
}
export const getBondlyNftContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bondlyNft
}
export const getBondlyCommonNftMasterAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.bondlyCommonNftMaster &&
    sushi.contracts.bondlyCommonNftMaster.options.address
  )
}
export const getBondlyCommonNftMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bondlyCommonNftMaster
}
export const getExchangeBondlyNFTAddress = sushi => {
  return (
    sushi && sushi.contracts && sushi.contracts.exchangeBondlyNFT && sushi.contracts.exchangeBondlyNFT.options.address
  )
}
export const getExchangeBondlyNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeBondlyNFT
}
export const getBidBondlyNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidBondlyNFT && sushi.contracts.bidBondlyNFT.options.address
}
export const getBidBondlyNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidBondlyNFT
}
export const getDoggyBondlyMasterAddress = sushi => {
  return (
    sushi && sushi.contracts && sushi.contracts.doggyBondlyMaster && sushi.contracts.doggyBondlyMaster.options.address
  )
}
export const getDoggyBondlyMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyBondlyMaster
}
export const getExchangeDoggyNFTAddress = sushi => {
  return (
    sushi && sushi.contracts && sushi.contracts.exchangeDoggyNFT && sushi.contracts.exchangeDoggyNFT.options.address
  )
}
export const getExchangeDoggyNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeDoggyNFT
}
export const getBidDoggyNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidDoggyNFT && sushi.contracts.bidDoggyNFT.options.address
}
export const getBidDoggyNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidDoggyNFT
}
export const getDoggyAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggy && sushi.contracts.doggy.options.address
}
export const getDoggyContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggy
}
export const getDoggyNFTCommonStakeERC721EarnBakeAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.doggyNFTCommonStakeERC721EarnBake &&
    sushi.contracts.doggyNFTCommonStakeERC721EarnBake.options.address
  )
}
export const getDoggyNFTCommonStakeERC721EarnBakeContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyNFTCommonStakeERC721EarnBake
}
export const getDoggyNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyNFT && sushi.contracts.doggyNFT.options.address
}
export const getDoggyNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyNFT
}
export const getDoggyBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyBnbBlp && sushi.contracts.doggyBnbBlp.options.address
}
export const getDoggyBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyBnbBlp
}
export const getDoggyBakeBaseIDOAddress = sushi => {
  return (
    sushi && sushi.contracts && sushi.contracts.doggyBakeBaseIDO && sushi.contracts.doggyBakeBaseIDO.options.address
  )
}
export const getDoggyBakeBaseIDOContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyBakeBaseIDO
}
export const getDoggyTlmMasterddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyTlmMaster && sushi.contracts.doggyTlmMaster.options.address
}
export const getDoggyTlmMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.doggyTlmMaster
}
export const getExchangeCarNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeCarNFT && sushi.contracts.exchangeCarNFT.options.address
}
export const getExchangeCarNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeCarNFT
}
export const getBidCarNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidCarNFT && sushi.contracts.bidCarNFT.options.address
}
export const getBidCarNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidCarNFT
}
export const getCarBakeBaseIdoAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.carBakeBaseIDO && sushi.contracts.carBakeBaseIDO.options.address
}
export const getCarBakeBaseIDOContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.carBakeBaseIDO
}
export const getCarNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.carNFT && sushi.contracts.carNFT.options.address
}
export const getCarNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.carNFT
}
export const getCarNFTStakingPowerTokenAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.carNFTStakingPowerToken &&
    sushi.contracts.carNFTStakingPowerToken.options.address
  )
}
export const getCarNFTStakingPowerTokenContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.carNFTStakingPowerToken
}
export const getCarBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.carBnbBlp
}
export const getCarNFTMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.carNFTMaster && sushi.contracts.carNFTMaster.options.address
}
export const getCarNFTMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.carNFTMaster
}
export const getCarBlindBoxAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.carBlindBox && sushi.contracts.carBlindBox.options.address
}
export const getCarBlindBoxContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.carBlindBox
}
export const getCarAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.car && sushi.contracts.car.options.address
}
export const getCarContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.car
}
export const getYooshiNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.yooshiNFT && sushi.contracts.yooshiNFT.options.address
}
export const getYooshiNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.yooshiNFT
}
export const getExchangeYooshiNFTAddress = sushi => {
  return (
    sushi && sushi.contracts && sushi.contracts.exchangeYooshiNFT && sushi.contracts.exchangeYooshiNFT.options.address
  )
}
export const getExchangeYooshiNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeYooshiNFT
}
export const getBidYooshiNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidYooshiNFT && sushi.contracts.bidYooshiNFT.options.address
}
export const getBidYooshiNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidYooshiNFT
}
export const getTlmBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tlmBnbBlp
}
export const getAliceBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.aliceBnbBlp
}
export const getPetBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.petBnbBlp
}
export const getSoccerPokerGameBoxAddress = sushi => {
  return (
    sushi && sushi.contracts && sushi.contracts.soccerPokerGameBox && sushi.contracts.soccerPokerGameBox.options.address
  )
}
export const getSoccerPokerGameBoxContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.soccerPokerGameBox
}
export const getSoccerPokerGameBoxMasterAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.soccerPokerGameBoxMaster &&
    sushi.contracts.soccerPokerGameBoxMaster.options.address
  )
}
export const getSoccerPokerGameBoxMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.soccerPokerGameBoxMaster
}
export const getSoccerPokerGameBoxBurnByProxyMasterAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.soccerPokerGameBoxBurnByProxy &&
    sushi.contracts.soccerPokerGameBoxBurnByProxy.options.address
  )
}
export const getSoccerPokerGameBoxBurnByProxyContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.soccerPokerGameBoxBurnByProxy
}
export const getBidSfpNFTAddress = sushi => {
  return sushi && sushi.bidSfpNFTAddress
}
export const getExchangeSfpNFTAddress = sushi => {
  return sushi && sushi.exchangeSfpNFTAddress
}
export const getSfpAddress = sushi => {
  return sushi && sushi.contracts && sushi.sfpAddress
}
export const getSfpNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.sfpNFTAddress
}
export const getSfpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.sfp
}
export const getSfpNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.sfpNFT
}
export const getExchangeSfpNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeSfpNFT
}
export const getBidSfpNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidSfpNFT
}
export const getPokerCardAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pokerCard && sushi.contracts.pokerCard.options.address
}
export const getPokerCardContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pokerCard
}
export const getPokerCardStakingPowerTokenAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.pokerCardStakingPowerToken &&
    sushi.contracts.pokerCardStakingPowerToken.options.address
  )
}
export const getPokerCardStakingPowerTokenContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pokerCardStakingPowerToken
}
export const getPokerCardMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pokerCardMaster && sushi.contracts.pokerCardMaster.options.address
}
export const getPokerCardMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pokerCardMaster
}
export const getPokerBlindBoxAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pokerBlindBox && sushi.contracts.pokerBlindBox.options.address
}
export const getPokerBlindBoxContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pokerBlindBox
}
export const getPokerAddress = sushi => {
  return sushi && sushi.contracts && sushi.pokerAddress
}
export const getPokerBakeBaseIdoAddress = sushi => {
  return (
    sushi && sushi.contracts && sushi.contracts.pokerBakeBaseIDO && sushi.contracts.pokerBakeBaseIDO.options.address
  )
}
export const getPokerContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.poker
}
export const getPokerBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pokerBnbBlp
}
export const getPokerBakeBaseIDOContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pokerBakeBaseIDO
}

export const getDittoCommonNftMasterAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.dittoCommonNftMaster &&
    sushi.contracts.dittoCommonNftMaster.options.address
  )
}
export const getDittoAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dittoNft && sushi.contracts.dittoNft.options.address
}
export const getDittoNftContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dittoNft
}
export const getDittoCommonNftMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dittoCommonNftMaster
}
export const getTsaContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tsa
}
export const getTsaMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tsaMaster
}
export const getTsaBakeBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tsaBakeBlp
}
export const getTlmContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tlm
}
export const getTlmMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tlmMaster
}
export const getTlmBakeBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tlmBakeBlp
}
export const getTkoMaster2Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tkoMaster2
}
export const getOneInchBakeCommonNftMasterAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.oneInchBakeCommonNftMaster &&
    sushi.contracts.oneInchBakeCommonNftMaster.options.address
  )
}
export const getOneInchBakeCommonNftMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.oneInchBakeCommonNftMaster
}
export const getOneInchAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.oneInch && sushi.contracts.oneInch.options.address
}
export const getOneInchContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.oneInch
}
export const getTkoContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tko
}
export const getTkoMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tkoMaster
}
export const getTkoBakeBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tkoBakeBlp
}
export const getTkoCommonStakeERC721EarnERC20Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tkoCommonStakeERC721EarnERC20
}
export const getHyFiBakeBaseIdoContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.hyFiBakeBaseIdo
}
export const getHyFiBakeBaseIdoAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.hyFiBakeBaseIdo && sushi.contracts.hyFiBakeBaseIdo.options.address
}
export const getHyfiMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.hyfiMaster
}
export const getHyfiMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.hyfiMaster && sushi.contracts.hyfiMaster.options.address
}
export const getPet3MasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pet3Master
}
export const getPet3MasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pet3Master && sushi.contracts.pet3Master.options.address
}
export const getXDittoContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.xDitto
}
export const getSactMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.sactMaster
}
export const getSactMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.sactMaster && sushi.contracts.sactMaster.options.address
}
export const getSactBakeBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.sactBakeBlp
}
export const getSactBakeBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.sactBakeBlp && sushi.contracts.sactBakeBlp.options.address
}
export const getXDittoMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.xDittoMaster
}
export const getXDittoMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.xDittoMaster && sushi.contracts.xDittoMaster.options.address
}
export const getXDittoBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.xDittoBnbBlp
}
export const getXDittoBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.xDittoBnbBlp && sushi.contracts.xDittoBnbBlp.options.address
}
export const getGfxMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.gfxMaster
}
export const getGfxMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.gfxMaster && sushi.contracts.gfxMaster.options.address
}
export const getGamyfiBakeBaseIdoContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.gamyfiBakeBaseIdo
}
export const getGamyfiBakeBaseIdoAddress = sushi => {
  return sushi && sushi.contracts && sushi.gamyfiBakeBaseIdoAddress
}
export const getBakerySoccerStakingPowerTokenContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakerySoccerStakingPowerToken
}
export const getBakerySoccerStakingPowerTokenAddress = sushi => {
  return sushi && sushi.contracts && sushi.bakerySoccerStakingPowerTokenAddress
}
export const getExchangeBakerySoccerAddress = sushi => {
  return sushi && sushi.contracts && sushi.exchangeBakerySoccerAddress
}
export const getExchangeBakerySoccerContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeBakerySoccer
}
export const getBidBakerySoccerAddress = sushi => {
  return sushi && sushi.contracts && sushi.bidBakerySoccerAddress
}
export const getBidBakerySoccerContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidBakerySoccer
}
export const getBakerySoccerMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.bakerySoccerMasterAddress
}
export const getBakerySoccerMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakerySoccerMaster
}
export const getBakerySoccerAddress = sushi => {
  return sushi && sushi.contracts && sushi.bakerySoccerAddress
}
export const getBakerySoccerContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakerySoccer
}
export const getDfyMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.dfyMasterAddress
}
export const getDfyMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dfyMaster
}
export const getTctAddress = sushi => {
  return sushi && sushi.contracts && sushi.tctAddress
}
export const getTctContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tct
}
export const getTctBusdBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.tctBusdBlpAddress
}
export const getTctBusdBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tctBusdBlp
}
export const getTctMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.tctMasterAddress
}
export const getTctMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tctMaster
}
export const getSoccerBakeBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.soccerBakeBlpAddress
}
export const getSoccerBakeBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.soccerBakeBlp
}
export const getSoccerBnbBlpAddress = sushi => {
  return  sushi && sushi.contracts && sushi.contracts.soccerBnbBlp && sushi.contracts.soccerBnbBlp.options.address
}
export const getSoccerBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.soccerBnbBlp
}
export const getSoccerAddress = sushi => {
  return sushi && sushi.contracts && sushi.soccerAddress
}
export const getSoccerContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.soccer
}
export const getAutoBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.autoBnbBlpAddress
}
export const getAutoBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.autoBnbBlp
}
export const getAliceNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.aliceNftAddress
}
export const getAliceNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.aliceNft
}
export const getAliceCommonNftMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.aliceCommonNftMasterAddress
}
export const getAliceCommonNftMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.aliceCommonNftMaster
}
export const getAliceAddress = sushi => {
  return sushi && sushi.contracts && sushi.aliceAddress
}
export const getAliceContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.alice
}
export const getAliceMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.aliceMasterAddress
}
export const getAliceMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.aliceMaster
}
export const getBakeAliceBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.bakeAliceBlpAddress
}
export const getBakeAliceBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeAliceBlp
}
export const getOneInchBakeNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.oneInchBakeNFT
}
export const getOneInchBakeNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.oneInchBakeNFTAddress
}
export const getExchangeOneInchBakeNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeOneInchBakeNFT
}
export const getExchangeOneInchBakeNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.exchangeOneInchBakeNFTAddress
}
export const getBidOneInchBakeNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidOneInchBakeNFT
}
export const getBidOneInchBakeNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.bidOneInchBakeNFTAddress
}
export const getMxAddress = sushi => {
  return sushi && sushi.contracts && sushi.mxAddress
}
export const getMxContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.mx
}
export const getBakeMxBlPrContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeMxBlp
}
export const getBakeMxBlpAddress = sushi => {
  return sushi && sushi.bakeMxBlpAddress
}
export const getMxMasterAddress = sushi => {
  return sushi && sushi.mxMasterAddress
}
export const getMxMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.mxMaster
}
export const getDieselMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dieselMaster
}
export const getVoteForNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.voteForNFTAddress
}
export const getVoteForNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.voteForNFT
}
export const getTokocryptoNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.tokocryptoNftAddress
}
export const getTokocryptoNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokocryptoNft
}
export const getTokocryptoCommonNftMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.tokocryptoCommonNftMasterAddress
}
export const getTokocryptoCommonNftMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tokocryptoCommonNftMaster
}
export const getExchangeTokocryptoNFTAddress = sushi => {
  return sushi && sushi.exchangeTokocryptoNFTAddress
}
export const getBidTokocryptoNFTAddress = sushi => {
  return sushi && sushi.bidTokocryptoNFTAddress
}
export const getExchangeTokocryptoNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeTokocryptoNFT
}
export const getBidTokocryptoNftContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidTokocryptoNFT
}
export const getWarAddress = sushi => {
  return sushi && sushi.contracts && sushi.warAddress
}
export const getWarContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.war
}
export const getBakeWarBlprContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeWarBlp
}
export const getBakeWarBlpAddress = sushi => {
  return sushi && sushi.bakeWarBlpAddress
}
export const getWarMasterAddress = sushi => {
  return sushi && sushi.warMasterAddress
}
export const getWarMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.warMaster
}
export const getWar2MasterAddress = sushi => {
  return sushi && sushi.warMaster2Address
}
export const getWar2MasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.warMaster2
}
export const getSeascapeNFTAddress = sushi => {
  return sushi && sushi.contracts && sushi.seascapeNFTAddress
}
export const getSeascapeNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.seascapeNFT
}
export const getSeascapeCommonNftMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.seascapeCommonNftMasterAddress
}
export const getSeascapeCommonNftMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.seascapeCommonNftMaster
}
export const getExchangeSeascapeNFTAddress = sushi => {
  return sushi && sushi.exchangeSeascapeNFTAddress
}
export const getExchangeSeascapeNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeSeascapeNFT
}
export const getBidSeascapeNftAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidSeascapeNFTAddress
}
export const getBidSeascapeNftContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidSeascapeNFT
}
export const getPCWSBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.pCWSBnbBlpAddress
}
export const getPCWSBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pCWSBnbBlp
}
export const getPCWSBakeBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pCWSBakeBlp
}
export const getPCWSAddress = sushi => {
  return sushi && sushi.contracts && sushi.pCWSAddress
}
export const getPCWSContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pCWS
}
export const getPCWSMasterAddress = sushi => {
  return sushi && sushi.contracts && sushi.pCWSMasterAddress
}
export const getPCWSMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pCWSMaster
}
export const getBakeBananaBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.bakeBananaBlpAddress
}
export const getBakeBananaBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeBananaBlp
}
export const getBananaMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.BANANAMaster
}
export const getBananaMasterAddress = sushi => {
  return sushi && sushi.bananaMasterAddress
}
export const getBananaAddress = sushi => {
  return sushi && sushi.bananaAddress
}
export const getBananaContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.BANANA
}

export const getSoccerBakeBaseIDOContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.soccerBakeBaseIDO
}
export const getSoccerBakeBaseIDOAddress = sushi => {
  return sushi && sushi.soccerBakeBaseIDOAddress
}
export const getBusdAddress = sushi => {
  return sushi && sushi.busdAddress
}
export const getUsdtAddress = sushi => {
  return sushi && sushi.usdtAddress
}
export const getCrudeoilBakeBaseIDOContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.crudeoilBakeBaseIDO
}
export const getCrudeoilBakeBaseIDOAddress = sushi => {
  return sushi && sushi.crudeoilBakeBaseIDOAddress
}
export const getSpartanBakeBaseIDOContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.spartanBakeBaseIDO
}
export const getSpartanBakeBaseIDOAddress = sushi => {
  return sushi && sushi.spartanBakeBaseIDOAddress
}
export const getExchangeBakeryArtwork3NFTAddress = sushi => {
  return sushi && sushi.exchangeBakeryArtwork3NFTAddress
}
export const getBakeryArtwork3NFTAddress = sushi => {
  return sushi && sushi.bakeryArtwork3NFTAddress
}
export const getBakeryArtwork3NFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeryArtwork3NFT
}
export const getExchangeBakeryArtwork3NFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeBakeryArtwork3NFT
}
export const getBidBakeryArtwork3NFTAddress = sushi => {
  return sushi && sushi.bidBakeryArtwork3NFTAddress
}
export const getBidBakeryArtwork3NFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidBakeryArtwork3NFT
}
export const getDEFI100OLDMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.DEFI100OLDMaster
}
export const getDEFI100MasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.DEFI100Master
}
export const getDEFI100BakeBLPContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.DEFI100BakeBLP
}
export const getDEFI100Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.DEFI100
}
export const getAnkrAddress = sushi => {
  return sushi && sushi.ankrAddress
}
export const getAnkrContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ankr
}
export const getOnxAddress = sushi => {
  return sushi && sushi.onxAddress
}
export const getOnxContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.onx
}
export const getAethAddress = sushi => {
  return sushi && sushi.aethAddress
}
export const getAethContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.aeth
}
export const getAethMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.aethMaster
}
export const getAethMasterAddress = sushi => {
  return sushi && sushi.aethMasterAddress
}
export const getBRYBakeBLPContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.BRYBakeBLP
}
export const getBRYBakeBLPAddress = sushi => {
  return sushi && sushi.BRYBakeBLPAddress
}
export const getBRYContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.BRY
}
export const getBRYAddress = sushi => {
  return sushi && sushi.BRYAddress
}
export const getBRYMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.BRYMaster
}
export const getBRYMasterAddress = sushi => {
  return sushi && sushi.BRYMasterAddress
}
export const getSHIELDContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.SHIELD
}
export const getSHIELDAddress = sushi => {
  return sushi && sushi.SHIELDAddress
}
export const getSHIELDMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.SHIELDMaster
}
export const getSHIELDMasterAddress = sushi => {
  return sushi && sushi.SHIELDMasterAddress
}
export const getWSoteBakeBLPContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.wSoteBakeBLP
}
export const getWSoteBakeBLPAddress = sushi => {
  return sushi && sushi.wSoteBakeBLPAddress
}
export const getWSOTEContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.wSOTE
}
export const getWSOTEAddress = sushi => {
  return sushi && sushi.wSOTEAddress
}
export const getWSOTEMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.wSOTEMaster
}
export const getWSOTEMasterAddress = sushi => {
  return sushi && sushi.wSOTEMasterAddress
}
export const getTenContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.ten
}
export const getTenAddress = sushi => {
  return sushi && sushi.tenAddress
}
export const getTenMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tenMaster
}
export const getTenMasterAddress = sushi => {
  return sushi && sushi.tenMasterAddress
}
export const getTenPetNftMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tenPetNftMaster
}
export const getTenPetNftMasterAddress = sushi => {
  return sushi && sushi.tenPetNftMasterAddress
}
export const getTenBakeBLPContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.tenBakeBLP
}
export const getTenBakeBLPAddress = sushi => {
  return sushi && sushi.tenBakeBLPAddress
}
export const getBethBakeBLPContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bethBakeBLP
}
export const getBethContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.beth
}
export const getEth2MasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.eth2Master
}
export const getEth2MasterAddress = sushi => {
  return sushi && sushi.eth2MasterAddress
}
export const getHelmetNftCommonMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.helmetNftCommonMaster
}
export const getHelmetNftCommonMasterAddress = sushi => {
  return sushi && sushi.helmetNftCommonMasterAddress
}
export const getHelmetNftContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.helmetNft
}
export const getHelmetNftAddress = sushi => {
  return sushi && sushi.helmetNftAddress
}
export const getPetNFTCommonMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.petNFTCommonMaster
}
export const getPetNFTCommonMasterAddress = sushi => {
  return sushi && sushi.petNFTCommonMasterAddress
}
export const getWeaponNFTCommonMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.weaponNFTCommonMaster
}
export const getWeaponNFTCommonMasterAddress = sushi => {
  return sushi && sushi.weaponNFTCommonMasterAddress
}
export const getPetNftAddress = sushi => {
  return sushi && sushi.petNftAddress
}
export const getPetNftContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.petNft
}
export const getExchangePetNftAddress = sushi => {
  return sushi && sushi.exchangePetNftAddress
}
export const getExchangePetNftContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangePetNft
}
export const getBidPetNftAddress = sushi => {
  return sushi && sushi.bidPetNFTAddress
}
export const getBidPetNftContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidPetNFT
}
export const getBestTokenAddress = sushi => {
  return sushi && sushi.bestTokenAddress
}
export const getBestTokenContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bestToken
}
export const getBestMasterAddress = sushi => {
  return sushi && sushi.bestMasterAddress
}
export const getBestMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bestMaster
}
export const getBusdContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.busdToken
}
export const getUsdtContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.usdtToken
}
export const getNetworkId = sushi => {
  return sushi && sushi.networkId
}
export const getTransferAddress = sushi => {
  return sushi && sushi.transferAddress
}
export const getWeb3 = sushi => {
  return sushi && sushi.web3
}
export const getWeaponAddress = sushi => {
  return sushi && sushi.weaponAddress
}
export const getWeaponContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.weapon
}
export const getWeaponBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.weaponBnbBlp && sushi.contracts.weaponBnbBlp.options.address
}
export const getWeaponBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.weaponBnbBlp
}
export const getWeaponMasterAddress = sushi => {
  return sushi && sushi.weaponMasterAddress
}
export const getWeaponMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.weaponMaster
}
export const getWeaponNFTAddress = sushi => {
  return sushi && sushi.weaponNFTAddress
}
export const getWeaponNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.weaponNFT
}
export const getExchangeWeaponNFTAddress = sushi => {
  return sushi && sushi.exchangeWeaponNFTAddress
}
export const getExchangeWeaponNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeWeaponNFT
}
export const getBidWeaponNFTAddress = sushi => {
  return sushi && sushi.bidWeaponNFTAddress
}
export const getBidWeaponNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidWeaponNFT
}
export const getBinanceNftAddress = sushi => {
  return sushi && sushi.binanceNftAddress
}
export const getBinanceNftContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.binanceNft
}
export const getExchangeBinanceNftAddress = sushi => {
  return sushi && sushi.exchangeBinanceNftAddress
}
export const getExchangeBinanceNftContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeBinanceNft
}
export const getBidBinanceNftAddress = sushi => {
  return sushi && sushi.bidBinanceNFTAddress
}
export const getBidBinanceNftContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidBinanceNFT
}

export const getBakeryArtwork2NFTAddress = sushi => {
  return sushi && sushi.bakeryArtwork2NFTAddress
}
export const getBakeryArtwork2NFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeryArtwork2NFT
}
export const getExchangeBakeryArtwork2NFTAddress = sushi => {
  return sushi && sushi.exchangeBakeryArtwork2NFTAddress
}
export const getExchangeBakeryArtwork2NFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeBakeryArtwork2NFT
}
export const getBidBakeryArtwork2NFTAddress = sushi => {
  return sushi && sushi.bidBakeryArtwork2NFTAddress
}
export const getBidBakeryArtwork2NFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidBakeryArtwork2NFT
}

export const getDogeMemeNFTAddress = sushi => {
  return sushi && sushi.dogeMemeNFTAddress
}
export const getDogeMemeNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dogeMemeNFT
}
export const getExchangeDogeMemeNFTAddress = sushi => {
  return sushi && sushi.exchangeDogeMemeNFTAddress
}
export const getExchangeDogeMemeNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeDogeMemeNFT
}
export const getBidDogeMemeNFTAddress = sushi => {
  return sushi && sushi.bidDogeMemeNFTAddress
}
export const getBidDogeMemeNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidDogeMemeNFT
}
export const getReviewAddress = sushi => {
  return sushi && sushi.reviewAddress
}
export const getBakeryArtworkNFTAddress = sushi => {
  return sushi && sushi.bakeryArtworkNFTAddress
}
export const getBakeryArtworkNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeryArtworkNFT
}
export const getExchangeBakeryArtworkNFTAddress = sushi => {
  return sushi && sushi.exchangeBakeryArtworkNFTAddress
}
export const getExchangeBakeryArtworkNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeBakeryArtworkNFT
}
export const getBidBakeryArtworkNFTAddress = sushi => {
  return sushi && sushi.bidBakeryArtworkNFTAddress
}
export const getBidBakeryArtworkNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidBakeryArtworkNFT
}
export const getBakeryArtworkRouterAddress = sushi => {
  return sushi && sushi.bakeryArtworkRouterAddress
}
export const getBakeryArtworkRouterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeryArtworkRouter
}
export const getArtworkNftContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.digitalArtworkNft
}
export const getArtworkNftAddress = sushi => {
  return sushi && sushi.contracts && sushi.digitalArtworkNFTAddress
}
export const getExchangeArtworkNFTAddress = sushi => {
  return sushi && sushi.exchangeArtworkNFTAddress
}
export const getExchangeArtworkNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeArtworkNFT
}
// get digital artwork nft bid contract address
export const getBidDigitalArtworkNFTAddress = sushi => {
  return sushi && sushi.bidDigitalArtworkNFTAddress
}
// get digital artwork nft bid contract object
export const getBidDigitalArtworkNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidDigitalArtworkNFT
}

export const getExchangeEggNFTAddress = sushi => {
  return sushi && sushi.exchangeEggNFTAddress
}
export const getExchangeEggNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeEggNFT
}

export const getBidPetEggNFTAddress = sushi => {
  return sushi && sushi.bidPetEggNFTAddress
}
export const getBidPetEggNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidPetEggNFT
}

export const getPetEggNftAddress = sushi => {
  return sushi && sushi.petEggNftAddress
}

export const getPetMasterAddress = sushi => {
  return sushi && sushi.petMasterAddress
}

export const getPetMaster2Address = sushi => {
  return sushi && sushi.petMaster2Address
}
export const getPetAddress = sushi => {
  return sushi && sushi.petAddress
}

export const getPetEggNftContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.petEggNft
}

export const getPetMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.petMaster
}

export const getPetMaster2Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.petMaster2
}
export const getPetContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.pet
}

export const getDishMasterAddress = sushi => {
  return sushi && sushi.dishMasterAddress
}

export const getDishStakingPowerTokenAddress = sushi => {
  return sushi && sushi.dishStakingPowerTokenAddress
}
export const getDishAddress = sushi => {
  return sushi && sushi.dishAddress
}
export const getDishMasterContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dishMaster
}
export const getDishContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.dish
}
export const getBakeBnbBlpAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeBnbBlp && sushi.contracts.bakeBnbBlp.options.address
}
export const getBakeBnbBlpContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeBnbBlp
}
export const getExchangeNFTAddress = sushi => {
  return sushi && sushi.exchangeNFTAddress
}
export const getExchangeNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeNFT
}
export const getBidDishNFTAddress = sushi => {
  return sushi && sushi.bidDishNFTAddress
}
export const getBidDishNFTContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bidDishNFT
}
export const getNftHelperAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.nftHelper && sushi.contracts.nftHelper.options.address
}
export const getNftHelperContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.nftHelper
}
export const getMasterChefAddress = sushi => {
  return sushi && sushi.masterChefAddress
}
export const getSushiAddress = sushi => {
  return sushi && sushi.sushiAddress
}
export const getWethContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.weth
}
export const getMasterChefContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.masterChef
}
export const getSushiContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.sushi
}
export const getBakeDestroyedAddress = sushi => {
  return sushi && sushi.bakeDestroyedAddress
}
export const getBakeDestroyedManagerAddress = sushi => {
  return sushi && sushi.bakeDestroyedManagerAddress
}

// 最终流通量等于当前的总量减去下面两个数据
// 获取待销毁的数量 调用 下面的getEarned  lpToken是 上面的 getBakeDestroyedAddress, account 是 getBakeDestroyedManagerAddress
// 获取已经销毁的数量
export const getBakeDestroyed = async sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.sushi &&
    sushi.contracts.sushi.methods.balanceOf(sushi.deadAddress).call()
  )
}
export const getBakeInManagerAddress = async sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.sushi &&
    sushi.contracts.sushi.methods.balanceOf(sushi.bakeDestroyedManagerAddress).call()
  )
}

// default is bake mint pools
export const getFarms = (sushi, tokenName) => {
  // MINTTOKEN
  if (sushi) {
    let pools = sushi.contracts.pools
    // eslint-disable-next-line
    switch (tokenName) {
      case MINTTOKEN.BAKEV2:
        pools = sushi.contracts.poolsV2
        // console.log("---pools---",pools)
        break
      case MINTTOKEN.PET:
        pools = sushi.contracts.petPools
        break
      case MINTTOKEN.ALLNEW:
        pools = sushi.contracts.newPools
        break
      case MINTTOKEN.ENDED:
        pools = sushi.contracts.endedPools
        break
      case MINTTOKEN.OTHERS:
        pools = sushi.contracts.otherPools
        break
      case MINTTOKEN.ALLNFT:
        pools = sushi.contracts.allNftPools
        break
      case MINTTOKEN.BPET:
        pools = sushi.contracts.bPetPools
        break
      case MINTTOKEN.WEAPON:
        pools = sushi.contracts.weaponPools
        break
      case MINTTOKEN.BEST:
        pools = sushi.contracts.bestPools
        break
      case MINTTOKEN.WEAPONNFT:
        pools = sushi.contracts.weaponnftPools
        break
      case MINTTOKEN.PETNFT:
        pools = sushi.contracts.petNftPools
        break
      case MINTTOKEN.HELMETNFT:
        pools = sushi.contracts.helmetNftPools
        break
      case MINTTOKEN.SEASCAPENFT:
        pools = sushi.contracts.seascapeNftPools
        break
      case MINTTOKEN.TKONFT:
        pools = sushi.contracts.tokocryptoNftPools
        break
      case MINTTOKEN.HATNFT:
        pools = sushi.contracts.hatNftPools
        break
      case MINTTOKEN.ETH2MASTER:
        pools = sushi.contracts.eth2MasterPools
        break
      case MINTTOKEN.AETHMASTER:
        pools = sushi.contracts.aethMasterPools
        break
      case MINTTOKEN.AETHANDETH2:
        pools = sushi.contracts.aethAndEth2Pools
        break
      case MINTTOKEN.TEN:
        pools = sushi.contracts.springMasterPools
        break
      case MINTTOKEN.WSOTE:
        pools = sushi.contracts.wSOTEMasterPools
        break
      case MINTTOKEN.SHIELD:
        pools = sushi.contracts.SHIELDMasterPools
        break
      case MINTTOKEN.BRY:
        pools = sushi.contracts.BRYMasterPools
        break
      case MINTTOKEN.BAKESTAKING:
        pools = sushi.contracts.bakeStakingPools
        break
      case MINTTOKEN.DEFI100:
        pools = sushi.contracts.DEFI100MasterPools
        break
      case MINTTOKEN.DEFI100OLD:
        pools = sushi.contracts.DEFI100OLDMasterPools
        break
      case MINTTOKEN.BANANA:
        pools = sushi.contracts.BananaMasterPools
        break
      case MINTTOKEN.PCWS:
        pools = sushi.contracts.pCWSMasterPools
        break
      case MINTTOKEN.WAR:
        pools = sushi.contracts.warMasterPools
        break
      case MINTTOKEN.WAR2:
        pools = sushi.contracts.war2MasterPools
        break
      case MINTTOKEN.DIESEL:
        pools = sushi.contracts.dieselMasterPools
        break
      case MINTTOKEN.MX:
        pools = sushi.contracts.mxMasterPools
        break
      case MINTTOKEN.ALICE:
        pools = sushi.contracts.aliceMasterPools
        break
      case MINTTOKEN.ALICENFT:
        pools = sushi.contracts.aliceNftPools
        break
      case MINTTOKEN.BONDLYNFT:
        pools = sushi.contracts.bondlyNftPools
        break
      case MINTTOKEN.DFY:
        pools = sushi.contracts.dfyMasterPools
        break
      case MINTTOKEN.GFX:
        pools = sushi.contracts.gfxMasterPools
        break
      case MINTTOKEN.XDITTO:
        pools = sushi.contracts.xDittoMasterPools
        break
      case MINTTOKEN.SACT:
        pools = sushi.contracts.sactMasterPools
        break
      case MINTTOKEN.PET3:
        pools = sushi.contracts.pet3Pools
        break
      case MINTTOKEN.HYFI:
        pools = sushi.contracts.hyfiPools
        break
      case MINTTOKEN.GINU:
        pools = sushi.contracts.ginuPools
        break
      case MINTTOKEN.LEV:
        pools = sushi.contracts.levPools
        break
      case MINTTOKEN.BONDLY:
        pools = sushi.contracts.bondlyPools
        break
      case MINTTOKEN.TCT:
        pools = sushi.contracts.tctMasterPools
        break
      case MINTTOKEN.TKO:
        pools = sushi.contracts.tkoPools
        break
      case MINTTOKEN.TKONFTSTAKE:
        pools = sushi.contracts.tkoNftPools
        break
      case MINTTOKEN.BMMNFTSTAKE:
        pools = sushi.contracts.bakeMuskMixerNftPools
        break
      case MINTTOKEN.TOYNFTSTAKE:
        pools = sushi.contracts.toyNftPools
        break
      case MINTTOKEN.BMONCNFTSTAKE:
        pools = sushi.contracts.bmoncNftPools
        break
      case MINTTOKEN.NFTSTAKE:
        pools = sushi.contracts.nftStakingPools
        break
      case MINTTOKEN.ONEINCHBAKENFT:
        pools = sushi.contracts.oneInchBakeNftPools
        break
      case MINTTOKEN.TKO2:
        pools = sushi.contracts.tko2Pools
        break
      case MINTTOKEN.BNRG:
        pools = sushi.contracts.bnrgPools
        break
      case MINTTOKEN.TSA:
        pools = sushi.contracts.tsaPools
        break
      case MINTTOKEN.TLM:
        pools = sushi.contracts.tlmPools
        break
      case MINTTOKEN.XDITTONFT:
        pools = sushi.contracts.xdittoNftPools
        break
      case MINTTOKEN.TLM2:
        pools = sushi.contracts.doggyTlmPools
        break
      case MINTTOKEN.TLM3:
        pools = sushi.contracts.barkTlmPools
        break
      case MINTTOKEN.TLM4:
        pools = sushi.contracts.tokauTlmPools
        break
      case MINTTOKEN.BONDLY2:
        pools = sushi.contracts.bondly2Pools
        break
      case MINTTOKEN.TLM5:
        pools = sushi.contracts.gatTlmPools
        break
      case MINTTOKEN.WSG:
        pools = sushi.contracts.wsgPools
        break
      case MINTTOKEN.DOGO:
        pools = sushi.contracts.dogoPools
        break
      case MINTTOKEN.TOYNFT:
        pools = sushi.contracts.toynftEarnPools
        break
      case MINTTOKEN.BETHMASTER:
        pools = sushi.contracts.bethMasterPools
        break
      case MINTTOKEN.TOKAU:
        pools = sushi.contracts.tokauPools
        break
      case MINTTOKEN.EGG:
        pools = sushi.contracts.eggPools
        break
      case MINTTOKEN.KALATA:
        pools = sushi.contracts.kalataPools
        break
      case MINTTOKEN.DON:
        pools = sushi.contracts.donPools
        break
      case MINTTOKEN.NT:
        pools = sushi.contracts.ntPools
        break
      case MINTTOKEN.MONI:
        pools = sushi.contracts.moniPools
        break
      case MINTTOKEN.KXA:
        pools = sushi.contracts.kxaPools
        break
      case MINTTOKEN.NBL:
        pools = sushi.contracts.nblPools
        break
    }
    return pools.map(
      ({
        pid,
        name,
        symbol,
        icon,
        tokenAddress,
        tokenSymbol,
        tokenContract,
        lpAddress,
        lpContract,
        activityTime,
        amountDay,
        amountUnit,
        stakeIcon,
        ended,
        otherName,
        bethRoi,
        bakeRoi,
        stakeType,
        decimal
      }) => ({
        pid,
        id: symbol,
        name,
        symbol,
        lpToken: symbol,
        lpTokenAddress: lpAddress,
        lpContract,
        tokenAddress,
        tokenSymbol,
        tokenContract,
        earnToken: tokenSymbol,
        earnTokenAddress: sushi.contracts.sushi.options.address,
        icon,
        activityTime,
        amountDay,
        amountUnit,
        stakeIcon,
        ended,
        otherName,
        bethRoi,
        bakeRoi,
        stakeType,
        decimal
      })
    )
  } else {
    return []
  }
}

export const getPoolWeight = async (masterChefContract, lpTokenAddress) => {
  const { allocPoint } = await masterChefContract.methods.poolInfoMap(lpTokenAddress).call()
  const totalAllocPoint = await masterChefContract.methods.totalAllocPoint().call()
  return new BigNumber(allocPoint).div(new BigNumber(totalAllocPoint))
}

export const getTokenEarned = async (masterChefContract, lpToken, account) => {
  return masterChefContract.methods.pendingToken(lpToken, account).call()
}

export const getEarned = async (masterChefContract, lpToken, account) => {
  return masterChefContract.methods.pendingBake(lpToken, account).call()
}

export const getTokenPerBlock = async (masterChefContract) => {
  return masterChefContract.methods.tokenPerBlock().call()
}

export const getPetEarned = async (masterChefContract, lpToken, account) => {
  return masterChefContract.methods.pendingPet(lpToken, account).call()
}

// 新合约
export const getBpetEarned = async (masterChefContract, lpToken, account) => {
  return masterChefContract.methods.pendingPet(lpToken, account).call()
}

export const getWeaponEarned = async (masterChefContract, lpToken, account) => {
  return masterChefContract.methods.pendingWeapon(lpToken, account).call()
}

export const getPendingShare = async (weaponNFTCommonMaster, lpToken, account) => {
  return weaponNFTCommonMaster.methods.pendingShare(lpToken, account).call()
}

export const getTotalLPWethValue = async (
  masterChefContract,
  wethContract,
  lpContract,
  tokenContract,
  lpTokenAddress
) => {
  try {
    // Get balance of the token address
    const tokenAmountWholeLP = await tokenContract.methods.balanceOf(lpContract.options.address).call()
    const tokenDecimals = await tokenContract.methods.decimals().call()
    // Get the share of lpContract that masterChefContract owns
    const balance = await lpContract.methods.balanceOf(masterChefContract.options.address).call()
    // Convert that into the portion of total lpContract = p1
    const totalSupply = await lpContract.methods.totalSupply().call()
    // Get total weth value for the lpContract = w1
    const lpContractWeth = await wethContract.methods.balanceOf(lpContract.options.address).call()
    // Return p1 * w1 * 2
    const portionLp = new BigNumber(balance).div(new BigNumber(totalSupply))
    const lpWethWorth = new BigNumber(lpContractWeth)
    const totalLpWethValue = portionLp.times(lpWethWorth).times(new BigNumber(2))
    // Calculate
    const tokenAmount = new BigNumber(tokenAmountWholeLP).times(portionLp).div(new BigNumber(10).pow(tokenDecimals))
    const wethAmount = new BigNumber(lpContractWeth).times(portionLp).div(new BigNumber(10).pow(18))

    return {
      tokenAmount,
      wethAmount,
      totalWethValue: totalLpWethValue.div(new BigNumber(10).pow(18)),
      tokenPriceInWeth: wethAmount.div(tokenAmount),
      poolWeight: await getPoolWeight(masterChefContract, lpTokenAddress),
      lpBalanceOfMaster: new BigNumber(balance).div(new BigNumber(10).pow(18))
    }
  } catch (e) {
    console.error(e)
    return {
      tokenAmount: new BigNumber(0),
      wethAmount: new BigNumber(0),
      totalWethValue: new BigNumber(0),
      tokenPriceInWeth: new BigNumber(0),
      poolWeight: new BigNumber(0),
      lpBalanceOfMaster: new BigNumber(0)
    }
  }
}

export const getTokenPriceInWeth = async (lpAddress, wethContract, tokenContract) => {
  try {
    const tokenAmountWholeLP = await tokenContract.methods.balanceOf(lpAddress).call()
    const tokenDecimals = await tokenContract.methods.decimals().call()
    const lpContractWeth = await wethContract.methods.balanceOf(lpAddress).call()
    const tokenAmount = new BigNumber(tokenAmountWholeLP).div(new BigNumber(10).pow(tokenDecimals))
    const wethAmount = new BigNumber(lpContractWeth).div(new BigNumber(10).pow(18))
    return wethAmount.div(tokenAmount)
  } catch (e) {
    console.error(e)
    return new BigNumber(0)
  }
}

export const transferErc20 = async (tokenContract, from, to, amount) => {
  return tokenContract.methods.transfer(to, amount).send({ from })
}

export const transferBnb = async (web3, from, to, amount) => {
  return web3.eth.sendTransaction({ from, to, value: amount })
}

export const transferErc721 = async (erc721TokenContract, from, to, tokenId) => {
  return erc721TokenContract.methods.transferFrom(from, to, tokenId).send({ from })
}

export const approve = async (lpContract, masterChefContract, account) => {
  return lpContract.methods
    .approve(masterChefContract.options.address, ethers.constants.MaxUint256)
    .send({ from: account })
}

export const getNFTEarned = async (dishMasterContract, account) => {
  return dishMasterContract.methods.pendingBake(account).call()
}

export const setApprovalForAll = async (erc721Contract, toContract, account) => {
  return await erc721Contract.methods.setApprovalForAll(toContract.options.address, true).send({ from: account })
}

export const isApprovedForAll = async (account, erc721Contract, toContract) => {
  try {
    return await erc721Contract.methods.isApprovedForAll(account, toContract.options.address).call()
  } catch (e) {
    return false
  }
}

// 授权消费 NFT
export const approveERC721 = async (erc721Contract, dishMasterContract, tokenId, account) => {
  return erc721Contract.methods.approve(dishMasterContract.options.address, tokenId).send({ from: account })
}

// 查询这个token授权地址。 返回授权地址
export const getApprovedERC721 = async (erc721Contract, tokenId) => {
  return erc721Contract.methods.getApproved(tokenId).call()
}

// 授权消费 NFT tokenIds数组
export const approveBulkERC721 = async (erc721Contract, dishMasterContract, tokenIds, account) => {
  return erc721Contract.methods.approveBulk(dishMasterContract.options.address, tokenIds).send({ from: account })
}

// 查询tokenIds数组授权地址。 返回授权地址
export const getApprovedBulkERC721 = async (erc721Contract, tokenIds) => {
  return erc721Contract.methods.getApprovedBulk(tokenIds).call()
}

// 合成 amount 是bake数量
export const synthesis = async (dishMasterContract, amount, account) => {
  return dishMasterContract.methods
    .synthesis(new BigNumber(amount).times(new BigNumber(10).pow(18)).toString())
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(tx)
      return tx.transactionHash
    })
}

// 分解
export const decomposition = async (dishMasterContract, tokenId, account) => {
  return dishMasterContract.methods
    .decomposition(tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(tx)
      return tx.transactionHash
    })
}

// 抵押套餐
export const stakeDish = async (dishMasterContract, tokenId, account) => {
  return dishMasterContract.methods
    .stake(tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(tx)
      return tx.transactionHash
    })
}

// 解压套餐
export const unstakeDish = async (dishMasterContract, tokenId, account) => {
  return dishMasterContract.methods
    .unstake(tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(tx)
      return tx.transactionHash
    })
}

// 解压全部
export const unstakeAllDish = async (dishMasterContract, account) => {
  return dishMasterContract.methods
    .unstakeAll()
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(tx)
      return tx.transactionHash
    })
}

// 收割
export const harvestDish = async (dishMasterContract, account) => {
  return dishMasterContract.methods
    .stake('0')
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(tx)
      return tx.transactionHash
    })
}
// 对应下面的 getStaked
export const getStakedDish = async (dishMasterContract, account) => {
  try {
    const { 0: amount } = await dishMasterContract.methods.getUserInfo(account).call()
    return new BigNumber(amount)
  } catch {
    return new BigNumber(0)
  }
}

// 获取所有抵押中的BakerySoccer信息
export const getAllStakingBakerySoccer = async (bakerySoccerMaster, account) => {
  const userInfo = await bakerySoccerMaster.methods.getUserInfo(account).call()
  return userInfo[2]
}

// 获取所有没抵押中的BakerySoccer信息
export const getAllUnstakingBakerySoccern = async (bakerySoccerMaster, bakerySocceContract, account) => {
  const length = await bakerySocceContract.methods.balanceOf(account).call()
  return await Promise.all(
    Array.from(Array(Number(length)).keys()).map(async index => {
      return await bakerySocceContract.methods.tokenOfOwnerByIndex(account, `${index}`).call()
    })
  )
}

export const mintBakeryArtwork = async (bakeryArtworkContract, tokenURI, account) => {
  const mintFeeAmount = await bakeryArtworkContract.methods.mintFeeAmount().call()
  return bakeryArtworkContract.methods
    .mint(account, tokenURI)
    .send({ from: account, value: mintFeeAmount })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

export const mintBakeryArtworkV2 = async (bakeryArtworkContract, tokenURI, creatorRoyalties, account) => {
  const mintFeeAmount = await bakeryArtworkContract.methods.mintFeeAmount().call()
  return bakeryArtworkContract.methods
    .mint(account, tokenURI, creatorRoyalties)
    .send({ from: account, value: mintFeeAmount })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

export const launchBakeryArtwork = async (
  bakeryArtworkRouterContract,
  bakeryArtworkContract,
  tokenURI,
  price,
  account
) => {
  const mintFeeAmount = await bakeryArtworkContract.methods.mintFeeAmount().call()
  return bakeryArtworkRouterContract.methods
    .launch(tokenURI, price)
    .send({ from: account, value: mintFeeAmount })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 第一次挂单, token id , price 是bake价格，记得乘于10的18次方
export const readyToSellToken = async (exchangeNFTContract, tokenId, price, account) => {
  return exchangeNFTContract.methods
    .readyToSellToken(tokenId, price)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 挂单成功后更新价格， 挂单前要授权tokenid 给exchangeNFT合约
export const setCurrentPrice = async (exchangeNFTContract, tokenId, price, account) => {
  return exchangeNFTContract.methods
    .setCurrentPrice(tokenId, price)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 取消挂单
export const cancelSellToken = async (exchangeNFTContract, tokenId, account) => {
  return exchangeNFTContract.methods
    .cancelSellToken(tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 获取挂单数量。
export const getAskLength = async exchangeNFTContract => {
  return await exchangeNFTContract.methods.getAskLength().call()
}
// 获取所有挂单
export const getAsks = async exchangeNFTContract => {
  return await exchangeNFTContract.methods.getAsks().call()
}
export const getAsksDesc = async exchangeNFTContract => {
  return await exchangeNFTContract.methods.getAsksDesc().call()
}
// 分页获取挂单
export const getAsksByPage = async (exchangeNFTContract, page, size) => {
  return await exchangeNFTContract.methods.getAsksByPage(page, size).call()
}
export const getAsksByPageDesc = async (exchangeNFTContract, page, size) => {
  return await exchangeNFTContract.methods.getAsksByPageDesc(page, size).call()
}
// 获取某个用户的挂单
export const getAsksByUser = async (exchangeNFTContract, account) => {
  return await exchangeNFTContract.methods.getAsksByUser(account).call()
}
export const getAsksByUserDesc = async (exchangeNFTContract, account) => {
  return await exchangeNFTContract.methods.getAsksByUserDesc(account).call()
}

// 购买token， 购买前要用给 exchangeNFT 合约授权bake。
export const buyToken = async (exchangeNFTContract, tokenId, account) => {
  return exchangeNFTContract.methods
    .buyToken(tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}
export const buyTokenV2 = async (exchangeNFTContract, tokenId, price, account) => {
  return exchangeNFTContract.methods
    .buyToken(tokenId, price)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 竞价NFT token，竞价前需要完成 bidNFT 一次性合约授权bake。
export const bidToken = async (bidNFTContract, tokenId, price, account) => {
  return bidNFTContract.methods
    .bidToken(tokenId, price)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 更新NFT token竞标价格
export const updateBidPrice = async (bidNFTContract, tokenId, price, account) => {
  return bidNFTContract.methods
    .updateBidPrice(tokenId, price)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 取消竞价
export const cancelBidToken = async (bidNFTContract, tokenId, account) => {
  return bidNFTContract.methods
    .cancelBidToken(tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 将token卖给指定竞价者
export const sellTokenTo = async (bidNFTContract, tokenId, to, account) => {
  return bidNFTContract.methods
    .sellTokenTo(tokenId, to)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

export const sellTokenToV2 = async (bidNFTContract, tokenId, price, to, account) => {
  return bidNFTContract.methods
    .sellTokenTo(tokenId, price, to)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 获取指定token的竞价数量。
export const getBidsLength = async (bidsNFTContract, tokenId) => {
  return await bidsNFTContract.methods.getBidsLength(tokenId).call()
}

// 获取指定token的竞价列表
export const getBids = async (bidsNFTContract, tokenId) => {
  return await bidsNFTContract.methods.getBids(tokenId).call()
}

// 获取指定地址的竞价列表
export const getUserBids = async (bidsNFTContract, account) => {
  return await bidsNFTContract.methods.getUserBids(account).call()
}

export const getPetEggInfo = async (petEggNftContract, tokenId) => {
  const petInfo = await petEggNftContract.methods.petInfoMap(tokenId).call()
  return {
    petType: Number(petInfo.petType),
    battlePower: Number(petInfo.battlePower),
    tokenId
  }
}

export const getDigitalArtworkInfo = async (petArtworkNftContract, tokenId) => {
  const artworkInfo = await petArtworkNftContract.methods.tokenURI(tokenId).call()
  const item = new Promise((resolve, reject) => {
    axios
      .get(artworkInfo, {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(e => {
        reject(e)
      })
  })
  // return {
  //   name: artworkInfo.name,
  //   description: artworkInfo.description,
  //   image: artworkInfo.image,
  //   attributes: {...artworkInfo.attributes}
  // }
  return item
}

export const getDishInfo = async (dishMasterContract, tokenId) => {
  const dishInfos = await dishMasterContract.methods.getDishInfo(tokenId).call()
  return {
    level: Number(dishInfos[0].level),
    stakingPowerMultiple: Number(dishInfos[0].stakingPowerMultiple),
    bakeAmount: new BigNumber(dishInfos[0].bakeAmount).div(new BigNumber(10).pow(18)),
    stakingPowerAmount: new BigNumber(dishInfos[0].stakingPowerAmount).div(new BigNumber(10).pow(18)),
    items: dishInfos[1],
    tokenId
  }
}

// 获取所有抵押中的dish信息
export const getAllStakingDishToken = async (dishMasterContract, account) => {
  const userInfo = await dishMasterContract.methods.getUserInfo(account).call()
  const stakingDishs = await Promise.all(
    Array.from(Array(Number(userInfo[2])).keys()).map(async index => {
      const tokenId = await dishMasterContract.methods.tokenOfStakerByIndex(account, `${index}`).call()
      return await getDishInfo(dishMasterContract, tokenId)
    })
  )
  return stakingDishs
}

// 获取所有抵押中的dish信息
export const getAllStakingDishTokenV2 = async (comboNFTCommonStakeERC721EarnBake2, dishMasterContract, account) => {
  const userInfo = await commonStakeERC721EarnBakeGetUserInfo(comboNFTCommonStakeERC721EarnBake2, account)
  const stakingDishs = await Promise.all(userInfo[2].map(async tokenId => {return await getDishInfo(dishMasterContract, tokenId)}))
  return stakingDishs
}


// 获取所有没抵押中的dish信息
export const getAllUnstakingDishToken = async (dishMasterContract, dishContract, account) => {
  const length = await dishContract.methods.balanceOf(account).call()
  const unstakingDishs = await Promise.all(
    Array.from(Array(Number(length)).keys()).map(async index => {
      const tokenId = await dishContract.methods.tokenOfOwnerByIndex(account, `${index}`).call()
      return await getDishInfo(dishMasterContract, tokenId)
    })
  )
  return unstakingDishs
}

// 计算某个dish的 roi
// 先计算当前dish池子每块出多少个bake。  用之前blockNum * (10/320)  其中10是dish池子点数， 320是总点数
// roi =  ((blockNum * (10/320)) * 30000 * 365) * (dish.stakingPowerAmount / getTotalStakingPower) / (dish.stakingPowerAmount/dish.stakingPowerMultiple)
// 简化后 roi = ((blockNum * (10/320)) * 30000 * 365) * (dish.stakingPowerMultiple / getTotalStakingPower)

// 上面是合成后的。

// 合成前的计算。 直接把dish.stakingPowerMultiple 替换成下面的倍数
// 3的平均staking power是投入的2倍
// 4的平均staking power是投入的2.6倍
// 5的平均staking power是投入的3倍
// 6的平均staking power是投入的3.3倍

// 获取抵押中所有stakingPowerToken.
export const getTotalStakingPower = async dishMasterContract => {
  return await dishMasterContract.methods.totalStakingPower().call()
}

export const getSushiSupply = async sushi => {
  return new BigNumber(await sushi.contracts.sushi.methods.totalSupply().call())
}

export const stake = async (masterChefContract, lpTokenAddress, amount, account) => {
  return masterChefContract.methods.deposit
    ? masterChefContract.methods
        .deposit(lpTokenAddress, new BigNumber(amount).times(new BigNumber(10).pow(18)).toString())
        .send({ from: account })
        .on('transactionHash', tx => {
          console.log(tx)
          return tx.transactionHash
        })
    : masterChefContract.methods
        .stake(lpTokenAddress, new BigNumber(amount).times(new BigNumber(10).pow(18)).toString())
        .send({ from: account })
        .on('transactionHash', tx => {
          console.log(tx)
          return tx.transactionHash
        })
}

export const unstake = async (masterChefContract, lpTokenAddress, amount, account) => {
  return masterChefContract.methods.withdraw
    ? masterChefContract.methods
        .withdraw(lpTokenAddress, new BigNumber(amount).times(new BigNumber(10).pow(18)).toString())
        .send({ from: account })
        .on('transactionHash', tx => {
          console.log(tx)
          return tx.transactionHash
        })
    : masterChefContract.methods
        .unstake(lpTokenAddress, new BigNumber(amount).times(new BigNumber(10).pow(18)).toString())
        .send({ from: account })
        .on('transactionHash', tx => {
          console.log(tx)
          return tx.transactionHash
        })
}
export const harvest = async (masterChefContract, lpTokenAddress, account) => {
  return masterChefContract.methods.deposit
    ? masterChefContract.methods
        .deposit(lpTokenAddress, '0')
        .send({ from: account })
        .on('transactionHash', tx => {
          console.log(tx)
          return tx.transactionHash
        })
    : masterChefContract.methods
        .stake(lpTokenAddress, '0')
        .send({ from: account })
        .on('transactionHash', tx => {
          console.log(tx)
          return tx.transactionHash
        })
}

export const getCommonMasterRemainToBeMint = async masterChefContract => {
  return new BigNumber(await masterChefContract.methods.totalToBeMintAmount().call()).minus(
    new BigNumber(await masterChefContract.methods.mintedAmount().call())
  )
}

export const getEth2MasterPendingToken = async (masterContract, lpTokenAddress, account) => {
  try {
    const {
      bakeReward,
      bethReward,
      bethRewardNow,
      convertToBakeReward,
      price,
      priceMultiple
    } = await masterContract.methods.pendingToken(lpTokenAddress, account).call()
    return {
      bakeReward: new BigNumber(bakeReward),
      bethReward: new BigNumber(bethReward),
      bethRewardNow: new BigNumber(bethRewardNow),
      convertToBakeReward: new BigNumber(convertToBakeReward),
      price: new BigNumber(price),
      priceMultiple: new BigNumber(priceMultiple)
    }
  } catch (e) {
    console.error(`getEth2MasterPendingToken ${e}`, e)
    const zero = new BigNumber(0)
    return {
      bakeReward: zero,
      bethReward: zero,
      bethRewardNow: zero,
      convertToBakeReward: zero,
      price: zero,
      priceMultiple: zero
    }
  }
}

/**
 *  getAethBakeBaseMasterPendingToken others [ANKR, ONX]
 * @param masterContract
 * @param lpTokenAddress
 * @param account
 * @returns {Promise<{otherRewards, nowOtherRewards, otherConvertToBakePrices, bakeReward: BigNumber, otherConvertToBakeRewards, priceMultiple: BigNumber}|{otherRewards: [BigNumber, BigNumber], nowOtherRewards: [BigNumber, BigNumber], otherConvertToBakePrices: [BigNumber, BigNumber], bakeReward: BigNumber, otherConvertToBakeRewards: [BigNumber, BigNumber], priceMultiple: BigNumber}>}
 */
export const getAethBakeBaseMasterPendingToken = async (masterContract, lpTokenAddress, account) => {
  try {
    const {
      bakeReward,
      otherRewards,
      nowOtherRewards,
      otherConvertToBakeRewards,
      otherConvertToBakePrices,
      priceMultiple
    } = await masterContract.methods.pendingToken(lpTokenAddress, account).call()
    return {
      bakeReward: new BigNumber(bakeReward),
      otherRewards: otherRewards.map(otherReward => new BigNumber(otherReward)),
      nowOtherRewards: nowOtherRewards.map(nowOtherReward => new BigNumber(nowOtherReward)),
      otherConvertToBakeRewards: otherConvertToBakeRewards.map(
        otherConvertToBakeReward => new BigNumber(otherConvertToBakeReward)
      ),
      otherConvertToBakePrices: otherConvertToBakePrices.map(
        otherConvertToBakePrice => new BigNumber(otherConvertToBakePrice)
      ),
      priceMultiple: new BigNumber(priceMultiple)
    }
  } catch (e) {
    console.error(`getEth2MasterPendingToken ${e}`, e)
    const zero = new BigNumber(0)
    return {
      bakeReward: zero,
      otherRewards: [zero, zero],
      nowOtherRewards: [zero, zero],
      otherConvertToBakeRewards: [zero, zero],
      otherConvertToBakePrices: [zero, zero],
      priceMultiple: zero
    }
  }
}

/**
 *
 * @param masterContract
 * @returns {Promise<{
      [poolAddress: string]: : {
        bethRoi: BigNumber
        bakeRoi: BigNumber
        rewardStartBlock: BigNumber
        rewardEndBlock: BigNumber
        amount: BigNumber
        bethValueRoi: BigNumber
        bakeValueRoi: BigNumber
      }
  }>}
 */
export const getEth2MasterPoolInfoMap = async masterContract => {
  try {
    const pools = await masterContract.methods.pools().call()
    return pools.addresses.reduce((tempPoolInfoMap, poolAddress, index) => {
      tempPoolInfoMap[poolAddress] = {
        ...pools.poolInfos[index],
        bethValueRoi: pools.bethValueRois[index],
        bakeValueRoi: pools.bakeValueRois[index]
      }
      return tempPoolInfoMap
    }, {})
  } catch (e) {
    console.error(`getEth2MasterPoolInfoMap ${e}`, e)
    return {}
  }
}

/**
 *
 * @param masterContract
 * @returns {Promise<{
      [poolAddress: string]: : {
        otherRois: BigNumber[]
        bakeRoi: BigNumber
        rewardStartBlock: BigNumber
        rewardEndBlock: BigNumber
        amount: BigNumber
        bakeValueRoi: BigNumber
        otherValueRois: BigNumber[]
      }
  }>}
 */
export const getAethMasterPoolInfoMap = async sushi => {
  try {
    const masterContract = getAethMasterContract(sushi)
    const aethContract = getAethContract(sushi)

    const calculateBakeValueRoiMultiple = async pair => {
      const pairContract = new sushi.web3.eth.Contract(BakerySwapPairAbi)
      pairContract.setProvider(sushi.provider)
      pairContract.options.address = pair
      const [aethAmountWholeBLP, totalSupply, aethBakePrice] = await Promise.all([
        aethContract.methods.balanceOf(pair).call(),
        pairContract.methods.totalSupply().call(),
        masterContract.methods.getTokenBakePrice(getAethAddress(sushi)).call()
      ])
      return new BigNumber(totalSupply.toString())
        .div(new BigNumber(aethAmountWholeBLP.toString()))
        .div(2)
        .multipliedBy(new BigNumber(10).pow(8))
        .div(new BigNumber(aethBakePrice.toString()))
    }
    const pools = await masterContract.methods.pools().call()

    const bakeValueRoiMultipleMap = {}
    const tokenBakePriceMap = {}
    await Promise.all(
      pools.tokens.map(async token => {
        tokenBakePriceMap[token] = new BigNumber(
          (await masterContract.methods.getTokenBakePrice(token).call()).toString()
        )
      })
    )
    await Promise.all(
      pools.addresses.map(async poolAddress => {
        bakeValueRoiMultipleMap[poolAddress] = await calculateBakeValueRoiMultiple(poolAddress)
      })
    )
    return pools.addresses.reduce((tempPoolInfoMap, poolAddress, index) => {
      tempPoolInfoMap[poolAddress] = {
        ...pools.poolInfos[index],
        bakeValueRoi: new BigNumber(pools.poolInfos[index].bakeRoi.toString()).multipliedBy(
          bakeValueRoiMultipleMap[poolAddress]
        ),
        otherValueRois: [
          new BigNumber(pools.poolInfos[index].otherRois[0].toString())
            .multipliedBy(bakeValueRoiMultipleMap[poolAddress])
            .multipliedBy(tokenBakePriceMap[pools.tokens[0]])
            .div(new BigNumber(10).pow(8)),
          new BigNumber(pools.poolInfos[index].otherRois[1].toString())
            .multipliedBy(bakeValueRoiMultipleMap[poolAddress])
            .multipliedBy(tokenBakePriceMap[pools.tokens[1]])
            .div(new BigNumber(10).pow(8))
        ],
        poolAddress: pools.addresses[index]
      }
      return tempPoolInfoMap
    }, {})
  } catch (e) {
    console.error(`getAethMasterPoolInfoMap ${e}`, e)
    return {}
  }
}

export const harvestBake = async (masterContract, lpTokenAddress, account) => {
  return masterContract.methods
    .harvestBake(lpTokenAddress)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(tx)
      return tx.transactionHash
    })
}

export const harvestBeth = async (masterContract, lpTokenAddress, account) => {
  return masterContract.methods
    .harvestBeth(lpTokenAddress)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(tx)
      return tx.transactionHash
    })
}

export const harvestOther = async (masterContract, lpTokenAddress, otherTokenAddress, account) => {
  return masterContract.methods
    .harvestOther(lpTokenAddress, otherTokenAddress)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(tx)
      return tx.transactionHash
    })
}

export const getStaked = async (masterChefContract, lpTokenAddress, account) => {
  try {
    const { amount } = await masterChefContract.methods.poolUserInfoMap(lpTokenAddress, account).call()
    return new BigNumber(amount)
  } catch {
    return new BigNumber(0)
  }
}

export const redeem = async (masterChefContract, account) => {
  const now = new Date().getTime() / 1000
  if (now >= 1597172400) {
    return masterChefContract.methods
      .exit()
      .send({ from: account })
      .on('transactionHash', tx => {
        console.log(tx)
        return tx.transactionHash
      })
  } else {
    alert('pool not active')
  }
}

/**
 * getWeaponInfo
 * @param weaponNftContract
 * @param tokenId
 * @returns {Promise<{petToGet: BigNumber, tokenId: BigNumber, level: BigNumber, weaponType: BigNumber, bakeToGet: BigNumber, stakingPower: BigNumber}>}
 */
export async function getWeaponInfo(weaponNftContract, tokenId) {
  const weaponNftInfo = await weaponNftContract.methods.weaponInfoMap(tokenId).call()
  return {
    ...weaponNftInfo,
    tokenId
  }
}

export const getErc721Balance = async (nftHelper, erc721Address, account) => {
  return await nftHelper.methods.tokenOfOwner(erc721Address, account).call()
}

export const getBmoncNftBalance = (bep721Contract, listContract, address) => {
  return new Promise((resolve, reject) => {
    try{
      bep721Contract.methods.totalSupply().call((err, totalSupply) => {
        if (err) {
          reject(err)
          return
        }
        let counter = 0
        let finished = false
        let binamonIds = []

        for (let k = 0; k < totalSupply; k += 3000) {
          counter++
          let s = k
          listContract.methods.tokensOf(address, s + 1, s + 3000 > totalSupply ? totalSupply : s + 3000).call({gas: 50000000}, (err, result) => {
            counter--
            if (result) {
              for (let i = 0; i < result.length; i++) {
                let tokenId = s + 1 + i
                if (result[i] == 1) {
                  binamonIds.push(tokenId)
                }
              }
            }

            if (counter == 0 && !finished) {
              finished = true
              resolve(binamonIds)
            }
          })
        }
      })
    }catch(err){
      reject(err)
    }
  })
}

/**
 * 倒计时 等于 (rewardMintMinBlockNumbers-当前区块号)*3 单位秒
 * @param commonNftMasterContract
 * @param account
 * @returns {Promise<{
      [poolAddress: string]: {
        poolRewardStartBlock: BigNumber
        poolRewardEndBlock: BigNumber
        poolAccSharePerNFT: BigNumber
        poolExists: boolean
        amount: BigNumber
        lastUpdateBlock: BigNumber
        rewardDebt: BigNumber
        rewardShare: BigNumber
        lastShare: BigNumber
        rewardMintMinBlockNumbers: BigNumber
      }
    } >}
 */
export const getCommonNftMasterPoolUserInfos = async (commonNftMasterContract, account) => {
  const allPoolUserInfo = await commonNftMasterContract.methods.allPoolUserInfo(account).call()
  return allPoolUserInfo.userInfos.reduce((accumulateInfo, poolInfo, index) => {
    accumulateInfo[allPoolUserInfo.pools[index]] = {
      poolRewardStartBlock: allPoolUserInfo.poolInfos[index].rewardStartBlock,
      poolRewardEndBlock: allPoolUserInfo.poolInfos[index].rewardEndBlock,
      poolAccSharePerNFT: allPoolUserInfo.poolInfos[index].accSharePerNFT,
      poolExists: allPoolUserInfo.poolInfos[index].exists,
      ...poolInfo,
      rewardMintMinBlockNumbers: allPoolUserInfo.rewardMintMinBlockNumbers[index]
    }
    return accumulateInfo
  }, {})
}

export const bakeBaseIDODepositToken = async (bakeBaseIDOContract, account, token, amount) => {
  return bakeBaseIDOContract.methods
    .deposit(token, amount)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(tx)
      return tx.transactionHash
    })
}

export const bakeBaseIDODepositBNB = async (bakeBaseIDOContract, account, amount) => {
  return bakeBaseIDOContract.methods
    .deposit('0x0000000000000000000000000000000000000000', 0)
    .send({ from: account, value: amount })
    .on('transactionHash', tx => {
      console.log(tx)
      return tx.transactionHash
    })
}

export async function getRemainIdoAmount(bakeBaseIDOContract, account, token) {
  return await bakeBaseIDOContract.methods.getRemainIdoAmount(token, account).call()
}

export async function getRemainIdoBNBAmount(bakeBaseIDOContract, account) {
  return await bakeBaseIDOContract.methods
    .getRemainIdoAmount('0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', account)
    .call()
}

export async function getIdoStartBlock(bakeBaseIDOContract) {
  return await bakeBaseIDOContract.methods.startBlock().call()
}

export async function getIdoEndBlock(bakeBaseIDOContract) {
  return await bakeBaseIDOContract.methods.endBlock().call()
}

export async function getIdoMaxTotalIdoUSDAmount(bakeBaseIDOContract) {
  return await bakeBaseIDOContract.methods.maxTotalIdoUSDAmount().call()
}

export async function getIdoCurrentTotalIdoUSDAmount(bakeBaseIDOContract) {
  return await bakeBaseIDOContract.methods.currentTotalIdoUSDAmount().call()
}

/**
 *
 * @param voteForNFTContract
 * @param nftToken
 * @param payToken
 * @returns {Promise<{ price, enabled}>}
 */
export async function getVoteSettings(voteForNFTContract, nftToken, payToken) {
  return await voteForNFTContract.methods.nftTokenPayTokenVoteSettings(nftToken, payToken).call()
}

/**
 * 需要支付的数量 = voteSettings.price.mul(votes).mul(BigNumber.from(10).pow(18)).div(1e8)
 * @param voteForNFTContract
 * @param account
 * @param nftToken
 * @param payToken
 * @param tokenOwner
 * @param tokenId
 * @param votes
 * @returns {Promise<*>}
 */
export const voteNft = async (voteForNFTContract, account, nftToken, payToken, tokenOwner, tokenId, votes) => {
  return voteForNFTContract.methods
    .vote(nftToken, payToken, tokenId, tokenOwner, votes)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(tx)
      return tx.transactionHash
    })
}

export const commonStakeERC721EarnERC20Stake = async (commonStakeERC721EarnERC20, lpTokenAddress, tokenId, account) => {
  return commonStakeERC721EarnERC20.methods
    .stake(lpTokenAddress, tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`commonStakeERC721EarnERC20Stake ${tx}`)
      return tx.transactionHash
    })
}

export const commonStakeERC721EarnERC20BatchStake = async (
  commonStakeERC721EarnERC20,
  lpTokenAddress,
  tokenIds,
  account
) => {
  return commonStakeERC721EarnERC20.methods
    .batchStake(lpTokenAddress, tokenIds)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`commonStakeERC721EarnERC20BatchStake ${tx}`)
      return tx.transactionHash
    })
}

export const commonStakeERC721EarnERC20Unstake = async (
  commonStakeERC721EarnERC20,
  lpTokenAddress,
  tokenId,
  account
) => {
  return commonStakeERC721EarnERC20.methods
    .unstake(lpTokenAddress, tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`commonStakeERC721EarnERC20Unstake ${tx}`)
      return tx.transactionHash
    })
}

export const commonStakeERC721EarnERC20BatchUnstake = async (
  commonStakeERC721EarnERC20,
  lpTokenAddress,
  tokenIds,
  account
) => {
  return commonStakeERC721EarnERC20.methods
    .batchUnstake(lpTokenAddress, tokenIds)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`commonStakeERC721EarnERC20BatchUnstake ${tx}`)
      return tx.transactionHash
    })
}

export const commonStakeERC721EarnERC20Harvest = async (commonStakeERC721EarnERC20, lpTokenAddress, account) => {
  return commonStakeERC721EarnERC20.methods
    .harvest(lpTokenAddress)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`commonStakeERC721EarnERC20Harvest ${tx}`)
      return tx.transactionHash
    })
}

/**
 * 返回当前池子stake的nft 所有stakingPower, 已经收割的量, stake中的tokenId
 * @param commonStakeERC721EarnERC20
 * @param lpTokenAddress
 * @param account
 * @returns {Promise<[stakingPower, rewardDebt, tokenIds]>}
 */
export const commonStakeERC721EarnERC20GetUserInfo = async (commonStakeERC721EarnERC20, lpTokenAddress, account) => {
  return await commonStakeERC721EarnERC20.methods.getUserInfo(lpTokenAddress, account).call()
}

/**
 * 返回待收割数量
 * @param commonStakeERC721EarnEgetUserInfoRC20
 * @param lpToken
 * @param account
 * @returns {Promise<*>}
 */
export const commonStakeERC721EarnERC20PendingToken = async (commonStakeERC721EarnERC20, lpToken, account) => {
  return commonStakeERC721EarnERC20.methods.pendingToken(lpToken, account).call()
}

/**
 * 返回某个池子信息
 * @param commonStakeERC721EarnERC20
 * @param lpToken
 * @returns {Promise<{
    allocPoint: BigNumber;
    lastRewardBlock: BigNumber;
    accTokenPerShare: BigNumber;
    totalStakingPower: BigNumber;
    exists: boolean;
  }>}
 */
export const commonStakeERC721EarnERC20PoolInfoMap = async (commonStakeERC721EarnERC20, lpToken) => {
  return commonStakeERC721EarnERC20.methods.poolInfoMap(lpToken).call()
}

/**
 *  POKER mint 成 盲盒 pokerBlindBoxNFT
 * @param pokerBlindBoxContract
 * @param pokerAmount
 * @param account
 * @returns {Promise<*>}
 */
export const pokerBlindBoxContractMint = async (pokerBlindBoxContract, pokerAmount, account) => {
  return pokerBlindBoxContract.methods
    .mint(new BigNumber(pokerAmount).times(new BigNumber(10).pow(18)).toString())
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`pokerBlindBoxContractMint ${tx}`)
      return tx.transactionHash
    })
}

/**
 * 开盲盒
 * @param pokerBlindBoxContract
 * @param tokenId 盲盒NFT id
 * @param account
 * @returns {Promise<*>}
 */
export const pokerBlindBoxContractOpen = async (pokerBlindBoxContract, tokenId, account) => {
  return pokerBlindBoxContract.methods
    .open(tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`pokerBlindBoxContractOpen ${tx}`)
      return tx.transactionHash
    })
}

export const getPokerCardInfo = async (pokerCardContract, tokenId) => {
  const pokerCardInfo = await pokerCardContract.methods.pokerCardInfoMap(tokenId).call()
  return {
    stakingPower: new BigNumber(pokerCardInfo.stakingPower).div(new BigNumber(10).pow(18)),
    name: pokerCardInfo.name,
    image: `https://d3ggs2vjn5heyw.cloudfront.net/poker/${pokerCardInfo.name.replace(' ', '')}.gif`,
    tokenId
  }
}

/**
 * 获取抵押中的扑克牌
 * @param pokerCardMasterContract
 * @param pokerCardContract
 * @param account
 * @returns {Promise<unknown[]>}
 */
export const getAllStakingPokerCard = async (pokerCardMasterContract, pokerCardContract, account) => {
  const userInfo = await pokerCardMasterContract.methods.getUserInfo(account).call()
  return await Promise.all(
    userInfo[2].map(async tokenId => {
      return await getPokerCardInfo(pokerCardContract, tokenId)
    })
  )
}

/**
 * 获取余额中的扑克牌
 * @param sushi
 * @param account
 * @returns {Promise<unknown[]>}
 */
export const getBalancePokerCards = async (sushi, account) => {
  const tokenIds = await getErc721Balance(getNftHelperContract(sushi), getPokerCardAddress(sushi), account)
  return await Promise.all(
    tokenIds.map(async tokenId => {
      return await getPokerCardInfo(getPokerCardContract(sushi), tokenId)
    })
  )
}

/**
 *  POKER or Soccer mint 成 盲盒 soccerPokerGameBoNFT
 * @param soccerPokerGameBoxContract
 * @param tokenAddress
 * @param account
 * @returns {Promise<*>}
 */
export const soccerPokerGameBoxMint = async (soccerPokerGameBoxContract, tokenAddress, account) => {
  return soccerPokerGameBoxContract.methods
    .mint(tokenAddress)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`soccerPokerGameBoxMint ${tx}`)
      return tx.transactionHash
    })
}

/**
 * 开盲盒
 * @param soccerPokerGameBoxContract
 * @param tokenId 盲盒NFT id
 * @param account
 * @returns {Promise<*>}
 */
export const soccerPokerGameBoxOpen = async (soccerPokerGameBoxBurnByProxy, tokenId, account) => {
  return soccerPokerGameBoxBurnByProxy.methods
    .open(tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`soccerPokerGameBoxOpen ${tx}`)
      return tx.transactionHash
    })
}

/**
 * 返回当前已经mint的数据
 * @param soccerPokerGameBoxContract
 * @param account
 * @returns {Promise<{
    poker: BigNumber; // 所有用户 用poker总共mint了多少
    soccer: BigNumber; // 所有用户 用soccer总共mint了多少
    userPoker: BigNumber; // 当前用户 用poker总共mint了多少
    userSoccer: BigNumber; // 当前用户 用soccer总共mint了多少
    0: BigNumber;
    1: BigNumber;
    2: BigNumber;
    3: BigNumber;
  }>}
 */
export const getSoccerPokerGameBoxMintInfo = async (soccerPokerGameBoxContract, account) => {
  return await soccerPokerGameBoxContract.methods.mintInfo(account).call()
}

export const getSoccerPokerGameBoxInfo = tokenId => {
  return {
    titleName: 'BSC Game Box',
    name: 'SoccerPokerGameBox',
    image: 'https://d3ggs2vjn5heyw.cloudfront.net/images/SoccerPokerGameBox.svg',
    tokenId
  }
}

/**
 * 获取抵押中的GameBox
 * @param soccerPokerGameBoxMaster
 * @param account
 * @returns {Promise<unknown[]>}
 */
export const getAllStakingSoccerPokerGameBoxs = async (soccerPokerGameBoxMaster, account) => {
  const userInfo = await soccerPokerGameBoxMaster.methods.getUserInfo(account).call()
  return userInfo[2].map(async tokenId => getSoccerPokerGameBoxInfo(tokenId))
}

/**
 * 获取余额中的GameBox
 * @param sushi
 * @param account
 * @returns {Promise<unknown[]>}
 */
export const getBalanceSoccerPokerGameBoxs = async (sushi, account) => {
  const tokenIds = await getErc721Balance(getNftHelperContract(sushi), getSoccerPokerGameBoxAddress(sushi), account)
  return tokenIds.map(async tokenId => getSoccerPokerGameBoxInfo(tokenId))
}

/**
 *  CAR mint 成 盲盒 carBlindBoxNFT
 * @param carBlindBoxContract
 * @param carAmount
 * @param account
 * @returns {Promise<*>}
 */
export const carBlindBoxContractMint = async (carBlindBoxContract, carAmount, account) => {
  return carBlindBoxContract.methods
    .mint(new BigNumber(carAmount).times(new BigNumber(10).pow(18)).toString())
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

/**
 * 开盲盒
 * @param carBlindBoxContract
 * @param tokenId 盲盒NFT id
 * @param account
 * @returns {Promise<*>}
 */
export const carBlindBoxContractOpen = async (carBlindBoxContract, tokenId, account) => {
  return carBlindBoxContract.methods
    .open(tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`carBlindBoxContractOpen ${tx}`)
      return tx.transactionHash
    })
}

export const formatCarNFTInfo = async (carNFTInfo, tokenId) => {
  return {
    stakingPower: new BigNumber(carNFTInfo.stakingPower).div(new BigNumber(10).pow(18)),
    lockedCAR: new BigNumber(carNFTInfo.lockedCAR).div(new BigNumber(10).pow(18)),
    style: carNFTInfo.style.toString(),
    size: carNFTInfo.size.toString(),
    image: `https://d3ggs2vjn5heyw.cloudfront.net/car/car${carNFTInfo.style.toString()}.gif`,
    minImage: `https://d3ggs2vjn5heyw.cloudfront.net/car/carMin${carNFTInfo.style.toString()}.gif`,
    tokenId
  }
}

export const getCarNFTInfo = async (carNFTContract, tokenId) => {
  const carNFTInfo = await carNFTContract.methods.carInfoMap(tokenId).call()
  return formatCarNFTInfo(carNFTInfo, tokenId)
}

export const getCarNFTInfos = async (carNFTContract, tokenIds) => {
  const carNFTInfos = await carNFTContract.methods.carsInfo(tokenIds).call()
  return carNFTInfos.map((carNFTInfo, index) => formatCarNFTInfo(carNFTInfo, tokenIds[index]))
}
/**
 * 获取抵押中的CarNFT
 * @param carNFTMasterContract
 * @param carNFTContract
 * @param account
 * @returns {Promise<unknown[]>}
 */
export const getAllStakingCarNFTs = async (carNFTMasterContract, carNFTContract, account) => {
  const userInfo = await carNFTMasterContract.methods.getUserInfo(account).call()
  return await Promise.all(
    userInfo[2].map(async tokenId => {
      return await getCarNFTInfo(carNFTContract, tokenId)
    })
  )
}

/**
 * 获取余额中的CarNFT
 * @param sushi
 * @param account
 * @returns {Promise<unknown[]>}
 */
export const getBalanceCarNFTs = async (sushi, account) => {
  const tokenIds = await getErc721Balance(getNftHelperContract(sushi), getCarNFTAddress(sushi), account)
  return await Promise.all(
    tokenIds.map(async tokenId => {
      return await getCarNFTInfo(getCarNFTContract(sushi), tokenId)
    })
  )
}

/**
 * 锁币到CarNFT
 * @param carNFTMasterContract
 * @param carNFTId
 * @param tokenAmount 锁定数量
 * @param account
 * @returns {Promise<*>}
 */
export const carNFTMasterContractLockCAR = async (carNFTMasterContract, carNFTId, tokenAmount, account) => {
  return carNFTMasterContract.methods
    .lockCAR(carNFTId, tokenAmount)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`carNFTMasterContractLockCAR ${tx}`)
      return tx.transactionHash
    })
}

/**
 * 解锁币到CarNFT
 * @param carNFTMasterContract
 * @param carNFTId
 * @param tokenAmount 解锁数量
 * @param account
 * @returns {Promise<*>}
 */
export const carNFTMasterContractUnlockCAR = async (carNFTMasterContract, carNFTId, tokenAmount, account) => {
  return carNFTMasterContract.methods
    .unlockCAR(carNFTId, tokenAmount)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`carNFTMasterContractUnlockCAR ${tx}`)
      return tx.transactionHash
    })
}

/**
 * mint doggy nft
 * @param doggyNFTContract
 * @param doggyAmount
 * @param account
 * @returns {Promise<*>}
 */
export const doggyNFTContractMint = async (doggyNFTContract, doggyAmount, account) => {
  return doggyNFTContract.methods
    .mint(new BigNumber(doggyAmount).times(new BigNumber(10).pow(18)).toString())
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

export const commonStakeERC721EarnBakeStake = async (commonStakeERC721EarnBake, tokenId, account) => {
  return commonStakeERC721EarnBake.methods
    .stake(tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`commonStakeERC721EarnBakeStake ${tx}`)
      return tx.transactionHash
    })
}

export const commonStakeERC721EarnBakeBatchStake = async (commonStakeERC721EarnBake, tokenIds, account) => {
  return commonStakeERC721EarnBake.methods
    .batchStake(tokenIds)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`commonStakeERC721EarnBakeBatchStake ${tx}`)
      return tx.transactionHash
    })
}

export const commonStakeERC721EarnBakeUnstake = async (commonStakeERC721EarnBake, tokenId, account) => {
  return commonStakeERC721EarnBake.methods
    .unstake(tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`commonStakeERC721EarnBakeUnstake ${tx}`)
      return tx.transactionHash
    })
}

export const commonStakeERC721EarnBakeBatchUnstake = async (commonStakeERC721EarnBake, tokenIds, account) => {
  return commonStakeERC721EarnBake.methods
    .batchUnstake(tokenIds)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`commonStakeERC721EarnBakeBatchUnstake ${tx}`)
      return tx.transactionHash
    })
}

export const commonStakeERC721EarnBakeHarvest = async (commonStakeERC721EarnBake, account) => {
  return commonStakeERC721EarnBake.methods
    .harvest()
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`commonStakeERC721EarnBakeHarvest ${tx}`)
      return tx.transactionHash
    })
}

/**
 * 返回当前池子stake的nft 所有stakingPower, 已经收割的量, stake中的tokenId
 * @param commonStakeERC721EarnBake
 * @param account
 * @returns {Promise<[stakingPower, rewardDebt, tokenIds]>}
 */
export const commonStakeERC721EarnBakeGetUserInfo = async (commonStakeERC721EarnBake, account) => {
  return await commonStakeERC721EarnBake.methods.getUserInfo(account).call()
}

/**
 * 返回待收割数量
 * @param commonStakeERC721EarnBake
 * @param account
 * @returns {Promise<*>}
 */
export const commonStakeERC721EarnBakePendingToken = async (commonStakeERC721EarnBake, account) => {
  return commonStakeERC721EarnBake.methods.pendingBake(account).call()
}

/**
 * mint barking nft
 * @param doggyNFTContract
 * @param doggyAmount
 * @param account
 * @returns {Promise<*>}
 */
export const barkingNFTContractMint = async (barkingNFTContract, barkAmount, account) => {
  return barkingNFTContract.methods
    .mint(new BigNumber(barkAmount).times(new BigNumber(10).pow(18)).toString())
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

/**
 *
 * @param doggyEquipment
 * @param payToken
 * @param payAmount
 * @param account
 * @returns {Promise<*>}
 */
export const doggyEquipmentMint = async (doggyEquipment, payToken, payAmount, account) => {
  return doggyEquipment.methods
    .mint(payToken, payAmount)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}
/**
 *
 * @param doggyEquipment
/**
 *  matrixPlusBox mint
 * @param matrixPlusBox
 * @param payToken
 * @param amount
 * @param account
 * @returns {Promise<*>}
 */
export const doggyEquipmentMintByBNB = async (doggyEquipment, amount, account) => {
  return doggyEquipment.methods.mintByETH().send({ from: account, value: amount })
}
export const matrixPlusBoxContractMint = async (matrixPlusBox, payToken, amount, account) => {
  return matrixPlusBox.methods
    .mint(payToken, amount)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

export const doggyEquipmentGetEnableEquipmentIds = async doggyEquipment => {
  return doggyEquipment.methods.getEnableEquipmentIds().call()
}
export const matrixPlusBoxContractGetWaitingToMintLength = async matrixPlusBox => {
  return matrixPlusBox.methods.getWaitingToMintLength().call()
}
export const matrixPlusBoxContractGetPayTokenPrices = async (matrixPlusBox, payTokens) => {
  return matrixPlusBox.methods.getPayTokenPrices(payTokens).call()
}
